import {
  TRANSPARENT,
  CURRENT_COLOR,
  CURRENT_COLOR_LOWERCASE,
  WHITE_HEX,
  NOTIFICATION_BACKGROUND,
  NOTIFICATION_SHADOW,
  NOTIFICATION_BORDER
} from "./index-ts7drhwc.mjs";

// src/icons/apps.tsx
import { jsx } from "react/jsx-runtime";
var AppsIcon = ({ color, ...props }) => /* @__PURE__ */ jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 640",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    fill: color ?? CURRENT_COLOR_LOWERCASE,
    d: "M144 128C135.2 128 128 135.2 128 144L128 240C128 248.8 135.2 256 144 256L240 256C248.8 256 256 248.8 256 240L256 144C256 135.2 248.8 128 240 128L144 128zM96 144C96 117.5 117.5 96 144 96L240 96C266.5 96 288 117.5 288 144L288 240C288 266.5 266.5 288 240 288L144 288C117.5 288 96 266.5 96 240L96 144zM144 384C135.2 384 128 391.2 128 400L128 496C128 504.8 135.2 512 144 512L240 512C248.8 512 256 504.8 256 496L256 400C256 391.2 248.8 384 240 384L144 384zM96 400C96 373.5 117.5 352 144 352L240 352C266.5 352 288 373.5 288 400L288 496C288 522.5 266.5 544 240 544L144 544C117.5 544 96 522.5 96 496L96 400zM496 128L400 128C391.2 128 384 135.2 384 144L384 240C384 248.8 391.2 256 400 256L496 256C504.8 256 512 248.8 512 240L512 144C512 135.2 504.8 128 496 128zM400 96L496 96C522.5 96 544 117.5 544 144L544 240C544 266.5 522.5 288 496 288L400 288C373.5 288 352 266.5 352 240L352 144C352 117.5 373.5 96 400 96zM400 384C391.2 384 384 391.2 384 400L384 496C384 504.8 391.2 512 400 512L496 512C504.8 512 512 504.8 512 496L512 400C512 391.2 504.8 384 496 384L400 384zM352 400C352 373.5 373.5 352 400 352L496 352C522.5 352 544 373.5 544 400L544 496C544 522.5 522.5 544 496 544L400 544C373.5 544 352 522.5 352 496L352 400z"
  })
});

// src/components/CodingAgentIcon.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var CodingAgentIcon = ({ codingAgentId, size }) => {
  if (codingAgentId === null) {
    return /* @__PURE__ */ jsx2(AppsIcon, {
      height: size,
      width: size
    });
  }
  return /* @__PURE__ */ jsx2("img", {
    alt: "",
    "aria-hidden": true,
    "data-coding-agent-icon": codingAgentId,
    draggable: false,
    src: `/api/app-icon/coding-agent/${codingAgentId}.png`,
    style: { flexShrink: 0, height: size, width: size }
  });
};

// src/icons/custom-editor.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var CustomEditorIcon = ({
  size: sizeProp
}) => /* @__PURE__ */ jsx3("svg", {
  focusable: "false",
  role: "img",
  viewBox: "0 0 24 24",
  style: {
    width: sizeProp ?? 14,
    height: sizeProp ?? 14,
    flexShrink: 0
  },
  children: /* @__PURE__ */ jsx3("path", {
    fill: "none",
    stroke: CURRENT_COLOR,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.8",
    d: "m8 8-4 4 4 4m8-8 4 4-4 4m-2-10-4 12"
  })
});

// src/icons/editor.tsx
import { jsx as jsx4, jsxs } from "react/jsx-runtime";
var iconStyle = (size) => ({
  flexShrink: 0,
  height: size,
  width: size
});
var VsCodeIcon = ({ size }) => /* @__PURE__ */ jsx4("svg", {
  viewBox: "0 0 40 40",
  style: iconStyle(size),
  "aria-hidden": true,
  children: /* @__PURE__ */ jsx4("path", {
    fill: "#23A9F2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.02 34.13c.23.09.48.13.72.12.25-.01.49-.07.71-.18l5.93-2.85c.31-.15.56-.38.74-.66.18-.29.28-.62.28-.96V10.25c0-.34-.1-.67-.28-.96-.18-.28-.43-.51-.74-.66l-5.93-2.85c-.34-.16-.71-.22-1.08-.15-.36.06-.7.23-.96.5L14.05 16.48 9.11 12.73a1.2 1.2 0 0 0-1.53.07L5.99 14.24a1.2 1.2 0 0 0 0 1.77l4.29 3.92-4.29 3.91a1.2 1.2 0 0 0 0 1.77l1.59 1.44a1.2 1.2 0 0 0 1.53.07l4.94-3.75 11.36 10.36c.17.17.38.31.61.4Zm1.18-20.74-8.61 6.54 8.61 6.53V13.39Z"
  })
});
var CursorIcon = ({ size }) => /* @__PURE__ */ jsxs("svg", {
  viewBox: "0 0 40 40",
  style: iconStyle(size),
  "aria-hidden": true,
  children: [
    /* @__PURE__ */ jsx4("rect", {
      x: "4",
      y: "4",
      width: "32",
      height: "32",
      rx: "7.625",
      fill: "#050505"
    }),
    /* @__PURE__ */ jsx4("path", {
      fill: "#fff",
      d: "m29.62 14.21-8.67-5.09a.89.89 0 0 0-.9 0l-8.67 5.09a.77.77 0 0 0-.38.66v10.26c0 .27.14.52.38.66l8.67 5.09c.28.16.62.16.9 0l8.67-5.09c.24-.14.38-.39.38-.66V14.87a.77.77 0 0 0-.38-.66Zm-.54 1.07L20.7 30.01a.11.11 0 0 1-.2-.06v-9.64c0-.19-.1-.37-.27-.47l-8.22-4.82a.11.11 0 0 1 .06-.21h16.74c.24 0 .39.27.27.47Z"
    })
  ]
});
var WindsurfIcon = ({ size }) => /* @__PURE__ */ jsx4("svg", {
  viewBox: "0 0 24 24",
  style: iconStyle(size),
  "aria-hidden": true,
  children: /* @__PURE__ */ jsx4("path", {
    fill: CURRENT_COLOR,
    d: "M23.55 5.07a2.18 2.18 0 0 0-2.18 2.17v4.87c0 .97-.8 1.76-1.76 1.76-.57 0-1.14-.29-1.47-.77l-4.97-7.1a2.21 2.21 0 0 0-3.96 1.22v4.89c0 .97-.8 1.76-1.77 1.76-.57 0-1.13-.29-1.47-.77L.41 5.16A.22.22 0 0 0 0 5.29v4.24c0 .22.07.43.19.6l5.47 7.82c.33.46.8.81 1.35.93a2.15 2.15 0 0 0 2.65-2.1v-4.89c0-.97.79-1.76 1.76-1.76.57 0 1.14.29 1.47.77l4.98 7.1c.41.59 1.05.94 1.81.94a2.15 2.15 0 0 0 2.15-2.16v-4.89c0-.97.79-1.76 1.76-1.76h.19a.22.22 0 0 0 .22-.22V5.29a.22.22 0 0 0-.22-.22h-.23Z"
  })
});
var ZedIcon = ({ size }) => /* @__PURE__ */ jsx4("svg", {
  viewBox: "0 0 40 40",
  style: iconStyle(size),
  "aria-hidden": true,
  children: /* @__PURE__ */ jsx4("path", {
    fill: CURRENT_COLOR,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3 7.4a.9.9 0 0 0-.9.9v19.8H5.6V8.3a2.7 2.7 0 0 1 2.7-2.7h24.11c1.2 0 1.81 1.45.96 2.3L18.52 22.76h4.18V20.9h1.8v2.31c0 .75-.6 1.35-1.35 1.35h-6.43l-3.1 3.09h14.03V16.4h1.8v11.25c0 1-.8 1.8-1.8 1.8H11.82L8.67 32.6H31.7a.9.9 0 0 0 .9-.9V11.9h1.8v19.8a2.7 2.7 0 0 1-2.7 2.7H7.59c-1.2 0-1.81-1.45-.96-2.31L21.43 17.3H17.3v1.8h-1.8v-2.25c0-.75.6-1.35 1.35-1.35h6.38l3.15-3.15H12.35V23.6h-1.8V12.35c0-1 .8-1.8 1.8-1.8h15.83l3.15-3.15H8.3Z"
  })
});
var VscodiumIcon = ({ size }) => /* @__PURE__ */ jsx4("svg", {
  viewBox: "0 0 24 24",
  style: iconStyle(size),
  "aria-hidden": true,
  children: /* @__PURE__ */ jsx4("path", {
    fill: "#2F80ED",
    d: "M11.58.54a1.47 1.47 0 0 0-.44 2.03c2.43 3.76 3 6.6 2.75 9.08-1 4.75-3.18 5.72-5.09 5.72-1.86 0-1.36-3.07.03-3.96a5.3 5.3 0 0 1 2.73-.87 1.47 1.47 0 1 0 0-2.94c-.96 0-1.9.21-2.78.55.18-.85.25-1.76.02-2.74-.36-1.47-1.37-2.88-3.13-4.25a1.47 1.47 0 0 0-1.81 2.32c1.43 1.11 1.9 1.94 2.07 2.62.16.68.03 1.4-.3 2.4-.41 1.35-.9 2.56-1.1 3.71-.11.57-.12 1.19-.15 1.68-1.03-1-1.43-2.34-1.43-4.28a1.47 1.47 0 1 0-2.95 0c0 2.66.78 5.18 2.86 6.87 1.88 1.79 6.67 1.13 6.67 4.01 0 .81 1.19 1.21 2 1.21.84 0 1.89-.56 1.89-1.21 0-3.27 3.44-5.25 9.11-5.24A1.47 1.47 0 1 0 22.53 14.3c-.39 0-.77.01-1.14.03.64-1.49.92-3.13.86-4.9a1.47 1.47 0 1 0-2.95.1c.08 2.32-.01 4.39-1.74 5.48-.49.31-1.06.58-1.6.58.42-1.14.74-2.35.87-3.65.08-.83.09-1.82 0-2.59-.15-1.18-.33-2.53.12-3.55.4-.87 1.31-1.24 2.65-1.24a1.47 1.47 0 1 0 0-2.94c-1.98 0-3.48 1.04-4.34 2.3-.44-.95-.98-1.93-1.64-2.94a1.47 1.47 0 0 0-2.04-.44Z"
  })
});
var WebStormIcon = ({ size }) => /* @__PURE__ */ jsxs("svg", {
  viewBox: "0 0 24 24",
  style: iconStyle(size),
  "aria-hidden": true,
  children: [
    /* @__PURE__ */ jsx4("rect", {
      width: "24",
      height: "24",
      rx: "3",
      fill: "#07C3F2"
    }),
    /* @__PURE__ */ jsx4("path", {
      fill: "#050505",
      d: "M3 3h18v18H3z"
    }),
    /* @__PURE__ */ jsx4("path", {
      fill: "#fff",
      d: "M4.8 5.4h2.1l1.3 4.9 1.4-4.9h1.6l1.4 4.9 1.3-4.9h2.1l-2.5 8.7h-1.8l-1.3-4.8-1.4 4.8H7.3L4.8 5.4Zm10.8 7.3 1.1-1.4c.8.6 1.6 1 2.5 1 .7 0 1.2-.3 1.2-.8 0-.5-.3-.7-1.7-1.1-1.7-.4-2.8-.9-2.8-2.6 0-1.6 1.3-2.6 3-2.6 1.2 0 2.3.4 3.2 1.1l-1 1.5c-.8-.5-1.5-.8-2.2-.8-.7 0-1.1.3-1.1.7 0 .6.4.7 1.8 1.1 1.7.5 2.7 1.1 2.7 2.6 0 1.7-1.3 2.7-3.2 2.7-1.3 0-2.6-.5-3.5-1.4ZM4.7 18h8v1.3h-8V18Z"
    })
  ]
});
var SublimeTextIcon = ({ size }) => /* @__PURE__ */ jsxs("svg", {
  viewBox: "0 0 40 40",
  style: iconStyle(size),
  "aria-hidden": true,
  children: [
    /* @__PURE__ */ jsx4("path", {
      fill: "#FF9800",
      d: "M35.91 4.51c0-.37-.36-.59-.8-.48L4.8 11.44c-.44.11-.8.5-.8.87v7.58c0 .37.36.59.8.48l30.31-7.41c.44-.11.8-.5.8-.87V4.51Zm0 15.57c0-.38-.36-.59-.8-.49L4.8 27.01c-.44.1-.8.5-.8.87v7.57c0 .38.36.6.8.49l30.31-7.41c.44-.11.8-.5.8-.88v-7.57Z"
    }),
    /* @__PURE__ */ jsx4("path", {
      fill: "#F28C00",
      d: "M4 19.84c0 .37.36.76.8.87l30.32 7.41c.44.11.8-.11.8-.48v-7.58c0-.37-.36-.76-.8-.87L4.8 11.78c-.44-.11-.8.11-.8.48v7.58Z"
    })
  ]
});
var EditorIcon = ({ editorId, size: sizeProp }) => {
  const size = sizeProp ?? 14;
  switch (editorId) {
    case "vscode":
      return /* @__PURE__ */ jsx4(VsCodeIcon, {
        size
      });
    case "cursor":
      return /* @__PURE__ */ jsx4(CursorIcon, {
        size
      });
    case "windsurf":
      return /* @__PURE__ */ jsx4(WindsurfIcon, {
        size
      });
    case "zed":
      return /* @__PURE__ */ jsx4(ZedIcon, {
        size
      });
    case "vscodium":
      return /* @__PURE__ */ jsx4(VscodiumIcon, {
        size
      });
    case "webstorm":
      return /* @__PURE__ */ jsx4(WebStormIcon, {
        size
      });
    case "sublime-text":
      return /* @__PURE__ */ jsx4(SublimeTextIcon, {
        size
      });
    case "custom":
    case null:
      return /* @__PURE__ */ jsx4(CustomEditorIcon, {
        size
      });
    default:
      return null;
  }
};

// src/icons/finder.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var FinderIcon = ({ size }) => {
  return /* @__PURE__ */ jsx5("img", {
    alt: "",
    "aria-hidden": true,
    "data-file-manager-icon": "finder",
    draggable: false,
    src: "/api/app-icon/file-manager/finder.png",
    style: { flexShrink: 0, height: size, width: size }
  });
};

// src/icons/terminal.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var iconStyle2 = (size) => ({
  flexShrink: 0,
  height: size,
  width: size
});
var simpleTerminalIcons = {
  warp: {
    color: "#01A4FF",
    path: "M12.035 2.723h9.253A2.712 2.712 0 0 1 24 5.435v10.529a2.712 2.712 0 0 1-2.712 2.713H8.047Zm-1.681 2.6L6.766 19.677h5.598l-.399 1.6H2.712A2.712 2.712 0 0 1 0 18.565V8.036a2.712 2.712 0 0 1 2.712-2.712Z"
  },
  wezterm: {
    color: "#4E49EE",
    path: "M3.27 8.524c0-.623.62-1.007 2.123-1.007l-.5 2.757c-.931-.623-1.624-1.199-1.624-1.75zm4.008 6.807c0 .647-.644 1.079-2.123 1.15l.524-2.924c.931.624 1.6 1.175 1.6 1.774zm-2.625 5.992.454-2.708c3.603-.336 5.01-1.798 5.01-3.404 0-1.653-2.004-2.948-3.841-4.074l.668-3.548c.764.072 1.67.216 2.744.432l.31-2.469c-.81-.12-1.575-.168-2.29-.216L8.257 2.7l-2.363-.024-.453 2.684C1.838 5.648.43 7.158.43 8.764c0 1.63 2.004 2.876 3.841 3.954l-.668 3.716c-.859-.048-1.908-.192-3.125-.408L0 18.495c1.026.12 1.98.192 2.84.216l-.525 2.588zm15.553-1.894h2.673c.334-2.804.81-8.46 1.121-14.86h-2.553c-.071 1.51-.334 10.498-.43 11.241h-.071c-.644-2.42-1.169-4.386-1.813-6.782h-1.456c-.62 2.396-1.05 4.194-1.694 6.782h-.096c-.071-.743-.477-9.73-.525-11.24h-2.648c.31 6.399.763 12.055 1.097 14.86h2.625l1.838-7.12z"
  },
  alacritty: {
    color: "#F46D01",
    path: "m10.065 0-8.57 21.269h3.595l6.91-16.244 6.91 16.244h3.594l-8.57-21.269zm1.935 9.935c-.76666 1.8547-1.5334 3.7094-2.298 5.565 1.475 4.54 1.475 4.54 2.298 8.5.823-3.96.823-3.96 2.297-8.5-.76637-1.8547-1.5315-3.7099-2.297-5.565z"
  },
  "gnome-terminal": {
    color: CURRENT_COLOR,
    path: "M1.846 0A1.841 1.841 0 000 1.846v18.463c0 1.022.823 1.845 1.846 1.845h20.308A1.841 1.841 0 0024 20.31V1.846A1.841 1.841 0 0022.154 0H1.846zm0 .924h20.308c.512 0 .922.41.922.922v18.463c0 .511-.41.921-.922.921H1.846a.919.919 0 01-.922-.921V1.846c0-.512.41-.922.922-.922zm0 .922v18.463h20.308V1.846H1.846zm1.845 2.14l3.235 1.758v.836L3.69 8.477V7.385l2.243-1.207v-.033L3.69 5.076v-1.09zM7.846 9.23h3.693v.924H7.846V9.23zM0 21.736v.418C0 23.177.823 24 1.846 24h20.308A1.841 1.841 0 0024 22.154v-.418a2.334 2.334 0 01-1.846.918H1.846A2.334 2.334 0 010 21.736Z"
  }
};
var TerminalIcon = ({ terminalId, size }) => {
  const hasArtwork = terminalId === "terminal" || terminalId === "iterm2" || terminalId === "ghostty" || terminalId === "windows-terminal";
  if (hasArtwork) {
    return /* @__PURE__ */ jsx6("img", {
      alt: "",
      "aria-hidden": true,
      "data-terminal-icon": terminalId,
      draggable: false,
      src: `/api/app-icon/terminal/${terminalId}.png`,
      style: iconStyle2(size)
    });
  }
  const icon = simpleTerminalIcons[terminalId];
  if (!icon) {
    return /* @__PURE__ */ jsx6(AppsIcon, {
      "aria-hidden": true,
      "data-terminal-icon": terminalId,
      height: size,
      width: size
    });
  }
  return /* @__PURE__ */ jsx6("svg", {
    "aria-hidden": true,
    "data-terminal-icon": terminalId,
    style: iconStyle2(size),
    viewBox: "0 0 24 24",
    children: /* @__PURE__ */ jsx6("path", {
      d: icon.path,
      fill: icon.color
    })
  });
};

// src/components/call-api.ts
import {
  studioOperations as studioOperations2
} from "@remotion/studio-shared";

// src/helpers/enqueue-studio-source-mutation.ts
import { Internals as Internals4 } from "remotion";

// src/components/Timeline/pending-sequence-splits.ts
import { useCallback, useMemo } from "react";

// src/helpers/rebase-source-request.ts
var provenance = new WeakMap;
var indexes = new WeakMap;
var locationFields = new Set([
  "nodePath",
  "sequenceNodePath",
  "targetSequenceNodePath",
  "targetNodePath",
  "sourceNodePaths",
  "insertedNodePath"
]);
var envelopes = new Set([
  "edits",
  "captionPatches",
  "addedKeyframes",
  "movedKeyframes",
  "sequenceKeyframes",
  "effectKeyframes",
  "nodes",
  "duplicatedNodes",
  "splitNodes",
  "sequences",
  "captionTarget",
  "results",
  "insertedEffect"
]);
var mapSourcePaths = (value, map) => {
  if (Array.isArray(value)) {
    const mapped = value.map((item) => mapSourcePaths(item, map));
    return mapped.every((item, index) => item === value[index]) ? value : mapped;
  }
  if (value === null || typeof value !== "object") {
    return value;
  }
  const object = value;
  let result = object;
  for (const [key, child] of Object.entries(object)) {
    if (!locationFields.has(key) && !envelopes.has(key)) {
      continue;
    }
    const mapped = locationFields.has(key) && Array.isArray(child) && child.every((part) => typeof part === "string" || typeof part === "number") ? map(child, typeof object.absolutePath === "string" ? object.absolutePath : typeof object.fileName === "string" ? object.fileName : null) : mapSourcePaths(child, map);
    if (mapped !== child) {
      if (result === object) {
        result = { ...object };
      }
      result[key] = mapped;
    }
  }
  return result;
};
var markSourceRequestPaths = (value, mutations, uncertain) => {
  const appliedMutationIds = new Set(mutations.map(({ mutationId }) => mutationId));
  mapSourcePaths(value, (nodePath) => {
    provenance.set(nodePath, { appliedMutationIds, uncertain });
    return nodePath;
  });
};
var copySourcePathProvenance = (from, to) => {
  const source = provenance.get(from);
  if (source) {
    provenance.set(to, source);
  }
};
var captureSourceRequest = (body, mutations) => {
  const pendingIds = new Set(mutations.map(({ mutationId }) => mutationId));
  const root = typeof window === "undefined" ? "" : window.remotion_cwd ?? "";
  const changedFiles = new Set(mutations.flatMap((mutation) => mutation.files.map((file) => normalizeSourceFileName(file.absolutePath, root))));
  return mapSourcePaths(body, (nodePath, fileName) => {
    const source = provenance.get(nodePath);
    if (source?.uncertain || !source && changedFiles.size > 0 && (fileName === null || changedFiles.has(normalizeSourceFileName(fileName, root)))) {
      throw new Error("The source changed while this control was loading. Wait for the preview to update, then try again.");
    }
    const captured = [...nodePath];
    provenance.set(captured, {
      appliedMutationIds: new Set([...source?.appliedMutationIds ?? []].filter((id) => pendingIds.has(id))),
      uncertain: false
    });
    return captured;
  });
};
var normalizeSourceFileName = (fileName, root) => {
  const normalized = fileName.replace(/\\/g, "/");
  const absolute = /^(?:\/|[a-z]:\/)/i.test(normalized) ? normalized : `${root.replace(/\\/g, "/")}/${normalized}`;
  const parts = [];
  for (const part of absolute.split("/")) {
    if (part === "." || part === "") {
      continue;
    }
    if (part === "..") {
      parts.pop();
    } else {
      parts.push(part);
    }
  }
  const path = parts.join("/");
  return /^[a-z]:\//i.test(path) ? path.toLowerCase() : path;
};
var rebaseSourceRequest = (body, mutations, allowUnmarkedPaths, root) => {
  const relevantMutationIds = new Set(mutations.map(({ mutationId }) => mutationId));
  return mapSourcePaths(body, (originalPath, fileName) => {
    const source = provenance.get(originalPath);
    if (source?.uncertain || !source && !allowUnmarkedPaths) {
      throw new Error("The source changed while this control was loading. Wait for the preview to update, then try again.");
    }
    let nodePath = originalPath;
    const appliedMutationIds = new Set([...source?.appliedMutationIds ?? []].filter((id) => relevantMutationIds.has(id)));
    for (const mutation of mutations) {
      if (appliedMutationIds.has(mutation.mutationId)) {
        continue;
      }
      let byFile = indexes.get(mutation);
      if (!byFile) {
        byFile = new Map;
        for (const file of mutation.files) {
          const indexedPaths = new Map;
          for (const remapping of file.remappings) {
            if (remapping.oldNodePath === null) {
              continue;
            }
            const key = JSON.stringify(remapping.oldNodePath);
            if (!indexedPaths.has(key)) {
              indexedPaths.set(key, remapping.newNodePath);
            }
          }
          byFile.set(normalizeSourceFileName(file.absolutePath, root), indexedPaths);
        }
        indexes.set(mutation, byFile);
      }
      const byPath = fileName === null ? null : byFile.get(normalizeSourceFileName(fileName, root));
      const nextPath = byPath?.get(JSON.stringify(nodePath));
      if (nextPath === null) {
        throw new Error("This layer was removed before the edit could be saved. Undo its removal or select another layer.");
      }
      if (nextPath !== undefined) {
        nodePath = nextPath;
      }
      appliedMutationIds.add(mutation.mutationId);
    }
    if (nodePath !== originalPath) {
      nodePath = [...nodePath];
      provenance.set(nodePath, { appliedMutationIds, uncertain: false });
    }
    return nodePath;
  });
};

// src/helpers/sequence-node-path-mutations.ts
import { Internals } from "remotion";

// src/helpers/duplicated-element-selection.ts
var compositionId = null;
var pending = null;
var snapshot = null;
var listeners = new Set;
var cancelDuplicatedElementSelection = (request) => {
  if (request === null || pending !== request) {
    return;
  }
  pending = null;
  snapshot = null;
  for (const listener of listeners) {
    listener();
  }
};
var invalidateDuplicatedElementSelection = () => cancelDuplicatedElementSelection(pending);
var setDuplicationSelectionComposition = (id) => {
  if (compositionId !== id) {
    invalidateDuplicatedElementSelection();
    compositionId = id;
  }
};
var beginDuplicatedElementSelection = () => {
  invalidateDuplicatedElementSelection();
  if (compositionId === null) {
    return null;
  }
  pending = { compositionId, result: null, mutations: [] };
  return pending;
};
var publishSelection = () => {
  if (pending === null || pending.result === null) {
    return;
  }
  const ownIndex = pending.mutations.findIndex(({ mutation }) => mutation.mutationId === pending?.result?.mutationId);
  if (ownIndex === -1) {
    return;
  }
  let { nodes } = pending.result;
  let refreshAfter = null;
  let waitingForRefresh = false;
  for (let index = ownIndex;index < pending.mutations.length; index++) {
    const { mutation, appliedBeforeRefresh, sharesEarlierRefresh } = pending.mutations[index];
    const affectedFiles = new Set(mutation.files.map((file) => file.absolutePath));
    if (index !== ownIndex && !nodes.some((node) => affectedFiles.has(node.absolutePath))) {
      continue;
    }
    if (sharesEarlierRefresh) {
      invalidateDuplicatedElementSelection();
      return;
    }
    waitingForRefresh ||= appliedBeforeRefresh === null;
    if (appliedBeforeRefresh !== null) {
      refreshAfter = Math.max(refreshAfter ?? appliedBeforeRefresh, appliedBeforeRefresh);
    }
    if (index === ownIndex) {
      continue;
    }
    const byFile = new Map(mutation.files.map((file) => {
      const byPath = new Map;
      for (const mapping of file.remappings) {
        if (mapping.oldNodePath !== null && !byPath.has(JSON.stringify(mapping.oldNodePath))) {
          byPath.set(JSON.stringify(mapping.oldNodePath), mapping.newNodePath);
        }
      }
      return [file.absolutePath, byPath];
    }));
    const remapped = [];
    for (const node of nodes) {
      const byPath = byFile.get(node.absolutePath);
      let path = node.nodePath;
      for (let { length } = path;length > 0; length--) {
        const prefix = path.slice(0, length);
        const key = JSON.stringify(length === path.length ? prefix : [...prefix, "openingElement"]);
        const mapped = byPath?.get(key);
        if (mapped === null) {
          invalidateDuplicatedElementSelection();
          return;
        }
        if (mapped !== undefined) {
          path = length === path.length ? mapped : [...mapped.slice(0, -1), ...path.slice(length)];
          break;
        }
      }
      remapped.push({ ...node, nodePath: path });
    }
    nodes = remapped;
  }
  snapshot = waitingForRefresh || refreshAfter === null ? null : {
    request: pending,
    compositionId: pending.compositionId,
    nodes,
    refreshAfter
  };
  for (const listener of listeners) {
    listener();
  }
};
var resolveDuplicatedElementSelection = (request, mutationId, nodes) => {
  if (request === null || pending !== request) {
    return;
  }
  request.result = { mutationId, nodes };
  publishSelection();
};
var recordDuplicationSelectionMutation = (mutation) => {
  if (pending === null) {
    return;
  }
  pending.mutations.push({
    mutation,
    appliedBeforeRefresh: null,
    sharesEarlierRefresh: false
  });
  publishSelection();
};
var markDuplicationSelectionMutationsApplied = (mutations, fastRefreshes) => {
  if (pending === null) {
    return;
  }
  const positions = new Map(mutations.map((mutation, index) => [mutation.mutationId, index]));
  for (const entry of pending.mutations) {
    const position = positions.get(entry.mutation.mutationId);
    if (position !== undefined) {
      entry.appliedBeforeRefresh = fastRefreshes;
      entry.sharesEarlierRefresh ||= position > 0;
    }
  }
  publishSelection();
};
var getDuplicatedElementSelection = () => snapshot;
var subscribeToDuplicatedElementSelection = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// src/helpers/inserted-element-selection.ts
var pendingSelection = null;
var listeners2 = new Set;
var requestInsertedElementSelection = (selection) => {
  pendingSelection = selection;
  for (const listener of listeners2) {
    listener();
  }
};
var clearInsertedElementSelection = (selection) => {
  if (pendingSelection !== selection) {
    return;
  }
  pendingSelection = null;
  for (const listener of listeners2) {
    listener();
  }
};
var subscribeToInsertedElementSelection = (listener) => {
  listeners2.add(listener);
  return () => listeners2.delete(listener);
};
var getInsertedElementSelection = () => pendingSelection;

// src/helpers/source-mutation-queue.ts
var revision = 0;
var lastDispatchedRevision = 0;
var activeRevision = null;
var chain = Promise.resolve();
var getSourceMutationRevision = () => revision;
var getLastDispatchedSourceMutationRevision = () => lastDispatchedRevision;
var getActiveSourceMutationRevision = () => activeRevision;
var waitForSourceMutationQueue = () => chain;
var enqueueSourceMutation = (run, onQueued = null) => {
  const operation = { id: `source-operation-${++revision}`, revision };
  const next = chain.then(async () => {
    lastDispatchedRevision = operation.revision;
    activeRevision = operation.revision;
    try {
      return await run(operation);
    } finally {
      activeRevision = null;
    }
  });
  chain = next.then(() => {
    return;
  }, () => {
    return;
  });
  onQueued?.(operation);
  return next;
};

// src/helpers/sequence-node-path-mutations.ts
var pendingMutations = [];
var pendingDeletionRetirements = new Map;
var pendingDeletionRemappings = new Map;
var seenMutationIds = new Set;
var lastMutationByBuildHash = new Map;
var unchangedSince = new Map;
var installedBuildListeners = new Set;
var filesWithSourceOnlyRemappings = new Set;
var notifyInstalledBuild = () => {
  for (const listener of installedBuildListeners)
    listener();
};
var subscribeToInstalledMutationBuild = (listener) => {
  installedBuildListeners.add(listener);
  return () => {
    installedBuildListeners.delete(listener);
  };
};
var recordSequenceNodePathMutationBuild = (hash, mutationId) => {
  if (hash === undefined || mutationId === undefined) {
    lastMutationByBuildHash.clear();
    return;
  }
  const installedHash = typeof __webpack_hash__ === "string" ? __webpack_hash__ : null;
  if (installedHash !== null && lastMutationByBuildHash.has(installedHash)) {
    for (const previousHash of lastMutationByBuildHash.keys()) {
      if (previousHash === installedHash)
        break;
      lastMutationByBuildHash.delete(previousHash);
    }
  }
  const previousMutationId = lastMutationByBuildHash.get(hash);
  lastMutationByBuildHash.set(hash, mutationId);
  if (hash === installedHash && mutationId !== null && mutationId !== previousMutationId && pendingMutations.some((mutation) => mutation.mutationId === mutationId)) {
    notifyInstalledBuild();
  }
};
var recordUnchangedSequenceNodePathMutationBuild = (event) => {
  if (!seenMutationIds.has(event.sourceMutationId) || pendingMutations.some((mutation) => mutation.mutationId === event.sourceMutationId)) {
    unchangedSince.set(event.sourceMutationId, event.previousMutationId);
  }
  recordSequenceNodePathMutationBuild(event.hash, event.sourceMutationId);
};
var hasSourceOnlyRemappings = (fileName) => {
  if (filesWithSourceOnlyRemappings.size === 0) {
    return false;
  }
  const root = typeof window === "undefined" ? "" : window.remotion_cwd ?? "";
  return filesWithSourceOnlyRemappings.has(normalizeSourceFileName(fileName, root));
};
var mutationListeners = new Set;
var getPendingSequenceNodePathMutations = () => pendingMutations.slice();
var prepareSequenceSourceRead = () => {
  const mutations = getPendingSequenceNodePathMutations();
  const sourceRevision = seenMutationIds.size;
  const activeRevision = getActiveSourceMutationRevision();
  const dispatchedRevision = getLastDispatchedSourceMutationRevision();
  const uncertain = activeRevision !== null;
  return (response) => {
    const current = !uncertain && getActiveSourceMutationRevision() === null && dispatchedRevision === getLastDispatchedSourceMutationRevision() && sourceRevision === seenMutationIds.size;
    markSourceRequestPaths(response, mutations, !current);
    return current;
  };
};
var withSequenceSourceRead = async (fileNames, run) => {
  const root = typeof window === "undefined" ? "" : window.remotion_cwd ?? "";
  const files = new Set(fileNames.map((fileName) => normalizeSourceFileName(fileName, root)));
  const receivedMutations = getPendingSequenceNodePathMutations();
  const unsubscribe = subscribeToSequenceNodePathMutations((mutation) => receivedMutations.push(mutation));
  try {
    for (let attempt = 0;attempt < 3; attempt++) {
      const finishRead = prepareSequenceSourceRead();
      const result = await run();
      if (finishRead(result) && !receivedMutations.some((mutation) => mutation.files.some((file) => files.has(normalizeSourceFileName(file.absolutePath, root))))) {
        return result;
      }
      await waitForSourceMutationQueue();
      if (receivedMutations.some((mutation) => mutation.files.some((file) => files.has(normalizeSourceFileName(file.absolutePath, root))))) {
        break;
      }
    }
    throw new Error("The source changed while loading controls. Wait for the preview to update, then try again.");
  } finally {
    unsubscribe();
  }
};
var queuePendingSequenceDeletionRemappings = (mutationId, remappings) => {
  const pending = pendingDeletionRemappings.get(mutationId) ?? [];
  pending.push(...remappings);
  pendingDeletionRemappings.set(mutationId, pending);
};
var subscribeToSequenceNodePathMutations = (listener) => {
  mutationListeners.add(listener);
  return () => {
    mutationListeners.delete(listener);
  };
};
var queueSequenceNodePathMutation = (mutation) => {
  if (seenMutationIds.has(mutation.mutationId)) {
    return;
  }
  seenMutationIds.add(mutation.mutationId);
  if (mutation.applyWithoutFastRefresh) {
    for (const file of mutation.files) {
      filesWithSourceOnlyRemappings.add(normalizeSourceFileName(file.absolutePath, ""));
    }
  }
  pendingMutations.push(mutation);
  recordDuplicationSelectionMutation(mutation);
  markSourceRequestPaths({
    results: [
      mutation.timelineSelection,
      ...mutation.files.flatMap((file) => file.remappings.flatMap((remapping) => remapping.newNodePath === null ? [] : [{ nodePath: remapping.newNodePath }]))
    ]
  }, pendingMutations, false);
  pendingDeletionRetirements.set(mutation.mutationId, Internals.OptimisticSequenceDeletion.prepareRetirement(mutation.files.flatMap((file) => file.remappings.flatMap((remapping) => remapping.oldNodePath === null ? [] : [
    {
      absolutePath: file.absolutePath,
      nodePath: remapping.oldNodePath
    }
  ])), getLastDispatchedSourceMutationRevision()));
  if (mutation.timelineSelection !== null) {
    requestInsertedElementSelection({
      compositionId: mutation.timelineSelection.compositionId,
      nodePath: {
        absolutePath: mutation.timelineSelection.absolutePath,
        nodePath: mutation.timelineSelection.nodePath
      },
      notification: null
    });
  }
  for (const listener of mutationListeners) {
    listener(mutation);
  }
  if (typeof __webpack_hash__ === "string" && lastMutationByBuildHash.get(__webpack_hash__) === mutation.mutationId) {
    notifyInstalledBuild();
  }
};
var queueSequenceNodePathMutationFromApiResponse = (response) => {
  if (typeof response !== "object" || response === null || !("nodePathMutation" in response)) {
    return;
  }
  const { nodePathMutation } = response;
  if (typeof nodePathMutation !== "object" || nodePathMutation === null || !("mutationId" in nodePathMutation) || typeof nodePathMutation.mutationId !== "string") {
    return;
  }
  queueSequenceNodePathMutation(nodePathMutation);
};
var takePendingSequenceNodePathMutations = (onlyWithoutFastRefresh = false) => {
  let lastCompiledIndex = onlyWithoutFastRefresh ? -1 : pendingMutations.length - 1;
  if (!onlyWithoutFastRefresh && lastMutationByBuildHash.size > 0 && typeof __webpack_hash__ === "string") {
    const mutationId = lastMutationByBuildHash.get(__webpack_hash__);
    lastCompiledIndex = pendingMutations.findIndex((mutation) => mutation.mutationId === mutationId);
  }
  const nextRefresh = pendingMutations.findIndex((mutation, index) => index > lastCompiledIndex && !mutation.applyWithoutFastRefresh);
  const mutations = pendingMutations.splice(0, nextRefresh === -1 ? pendingMutations.length : nextRefresh);
  let changes = mutations;
  if (mutations.length > 0 && unchangedSince.size > 0) {
    const indexes = new Map(mutations.map((mutation, i) => [mutation.mutationId, i]));
    changes = [];
    for (let i = mutations.length - 1;i >= 0; ) {
      const mutation = mutations[i];
      const previousId = unchangedSince.get(mutation.mutationId);
      if (previousId !== undefined) {
        const previousIndex = previousId === null ? -1 : indexes.get(previousId) ?? -1;
        if (previousIndex < i) {
          i = previousIndex;
          continue;
        }
      }
      changes.push(mutation);
      i--;
    }
    changes.reverse();
  }
  for (const mutation of mutations) {
    unchangedSince.delete(mutation.mutationId);
    pendingDeletionRetirements.get(mutation.mutationId)?.();
    pendingDeletionRetirements.delete(mutation.mutationId);
    const remappings = pendingDeletionRemappings.get(mutation.mutationId);
    if (remappings) {
      Internals.OptimisticSequenceDeletion.remap(remappings);
      pendingDeletionRemappings.delete(mutation.mutationId);
    }
  }
  return { mutations, changes };
};

// src/helpers/use-sync-external-store.ts
import { Internals as Internals2 } from "remotion";
var {
  useSyncExternalStore
} = Internals2;

// src/components/Timeline/pending-sequence-splits.ts
var pending2 = new Set;
var listeners3 = new Map;
var unsubscribe = null;
var timeline = null;
var sourceFileKey = (fileName) => normalizeSourceFileName(fileName, typeof window === "undefined" ? "" : window.remotion_cwd ?? "");
var keyForNode = (node) => JSON.stringify([node.absolutePath, node.nodePath]);
var publish = (keys) => {
  const callbacks = new Set;
  for (const key of keys)
    for (const callback of listeners3.get(key) ?? [])
      callbacks.add(callback);
  for (const callback of callbacks)
    callback();
};
var remove = (operation) => {
  if (!pending2.delete(operation))
    return;
  operation.onFinish();
  publish(operation.keys);
  if (pending2.size === 0) {
    unsubscribe?.();
    unsubscribe = null;
  }
};
var supersedePendingSequenceSplits = (nodes) => {
  for (const operation of [...pending2]) {
    if (!nodes.some((node) => operation.targets.some((target) => node.absolutePath === target.absolutePath && (operation.keys.has(keyForNode(node)) || node.nodePath.at(-1) === "openingElement" && node.nodePath.slice(0, -1).every((part, index) => target.nodePath[index] === part)))))
      continue;
    operation.superseded = true;
    if (operation.result)
      remove(operation);
  }
};
var clearPendingSequenceSplits = () => {
  for (const operation of [...pending2])
    remove(operation);
};
var getPendingSequenceSplits = () => [...pending2].flatMap((operation) => operation.targets.map(({ absolutePath, nodePath, splitFrame }) => ({
  absolutePath,
  nodePath,
  splitFrame
})));
var isSequenceSplitPending = (nodePathInfo) => {
  const key = keyForNode(nodePathInfo.sequenceSubscriptionKey);
  return [...pending2].some((operation) => operation.keys.has(key));
};
var useAreSequencesSplitting = (nodes) => {
  const keys = useMemo(() => nodes.map((node) => keyForNode(node.sequenceSubscriptionKey)), [nodes]);
  const subscribe = useCallback((callback) => {
    for (const key of keys) {
      let set = listeners3.get(key);
      if (!set) {
        set = new Set;
        listeners3.set(key, set);
      }
      set.add(callback);
    }
    return () => {
      for (const key of keys) {
        const set = listeners3.get(key);
        set?.delete(callback);
        if (set?.size === 0)
          listeners3.delete(key);
      }
    };
  }, [keys]);
  const getSnapshot = useCallback(() => [...pending2].some((operation) => keys.some((key) => operation.keys.has(key))), [keys]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};
var useIsSplittingSequence = (node) => {
  const nodes = useMemo(() => node ? [node] : [], [node]);
  return useAreSequencesSplitting(nodes);
};
var remapNodes = (nodes, mutation) => {
  const byFile = new Map(mutation.files.map((file) => {
    const byPath = new Map;
    for (const mapping of file.remappings)
      if (mapping.oldNodePath !== null && !byPath.has(JSON.stringify(mapping.oldNodePath)))
        byPath.set(JSON.stringify(mapping.oldNodePath), mapping.newNodePath);
    return [file.absolutePath, byPath];
  }));
  return nodes.flatMap((node) => {
    const map = byFile.get(node.absolutePath);
    for (let { length } = node.nodePath;length > 0; length--) {
      const key = JSON.stringify(length === node.nodePath.length ? node.nodePath : [...node.nodePath.slice(0, length), "openingElement"]);
      const mapped = map?.get(key);
      if (mapped === null)
        return [];
      if (mapped !== undefined)
        return [
          {
            ...node,
            nodePath: length === node.nodePath.length ? mapped : [...mapped.slice(0, -1), ...node.nodePath.slice(length)]
          }
        ];
    }
    return [node];
  });
};
var reconcile = () => {
  if (pending2.size === 0 || timeline === null)
    return;
  const byPath = new Map(timeline.tracks.flatMap((track) => track.nodePathInfo ? [
    [
      keyForNode(track.nodePathInfo.sequenceSubscriptionKey),
      track
    ]
  ] : []));
  for (const operation of [...pending2]) {
    if (!operation.result)
      continue;
    if (operation.compositionId !== null && operation.compositionId !== timeline.compositionId || operation.targets.length === 0) {
      remove(operation);
      continue;
    }
    if (operation.targets.every((target) => {
      const duration = byPath.get(keyForNode(target))?.sequence.duration;
      return duration !== undefined && Math.abs(duration - target.expectedDuration) <= 0.000000001;
    }) && operation.result.nodes.every((node) => byPath.has(keyForNode(node))))
      remove(operation);
  }
};
var beginPendingSequenceSplit = (targets, onFinish) => {
  if (targets.some(({ nodePathInfo }) => isSequenceSplitPending(nodePathInfo)))
    return null;
  const operation = {
    targets: targets.map(({ nodePathInfo, splitFrame, expectedDuration }) => ({
      absolutePath: nodePathInfo.sequenceSubscriptionKey.absolutePath,
      nodePath: nodePathInfo.sequenceSubscriptionKey.nodePath,
      splitFrame,
      expectedDuration
    })),
    keys: new Set(targets.map(({ nodePathInfo }) => keyForNode(nodePathInfo.sequenceSubscriptionKey))),
    compositionId: timeline?.compositionId ?? null,
    superseded: false,
    mutations: [],
    receivedSourceVersions: new Map,
    result: null,
    onFinish
  };
  pending2.add(operation);
  if (unsubscribe === null)
    unsubscribe = subscribeToSequenceNodePathMutations((mutation) => {
      for (const entry of pending2) {
        if (entry.result === null)
          entry.mutations.push(mutation);
        entry.targets = remapNodes(entry.targets, mutation);
        if (entry.result)
          entry.result.nodes = remapNodes(entry.result.nodes, mutation);
        for (const node of entry.targets)
          entry.keys.add(keyForNode(node));
        publish(entry.keys);
      }
      reconcile();
    });
  publish(operation.keys);
  return operation;
};
var finishPendingSequenceSplit = remove;
var acknowledgePendingSequenceSplit = (operation, mutationId, nodes, sourceVersions) => {
  if (!pending2.has(operation))
    return;
  if (operation.superseded || sourceVersions.some(({ absolutePath, sourceVersion }) => {
    const received = operation.receivedSourceVersions.get(sourceFileKey(absolutePath));
    return sourceVersion !== null && received?.sessionId === sourceVersion.sessionId && received.revision > sourceVersion.revision;
  })) {
    remove(operation);
    return;
  }
  const ownIndex = operation.mutations.findIndex((mutation) => mutation.mutationId === mutationId);
  let currentNodes = nodes;
  if (ownIndex >= 0)
    for (const mutation of operation.mutations.slice(ownIndex + 1))
      currentNodes = remapNodes(currentNodes, mutation);
  operation.result = {
    mutationId,
    nodes: currentNodes,
    sourceVersions: new Map(sourceVersions.map(({ absolutePath, sourceVersion }) => [
      sourceFileKey(absolutePath),
      sourceVersion
    ]))
  };
  operation.mutations = [];
  operation.receivedSourceVersions.clear();
  reconcile();
};
var reconcilePendingSequenceSplits = (snapshot) => {
  timeline = snapshot;
  reconcile();
};
var observePendingSequenceSplitSourceVersion = (absolutePath, sourceVersion) => {
  if (sourceVersion === null || pending2.size === 0)
    return;
  const fileKey = sourceFileKey(absolutePath);
  for (const operation of [...pending2]) {
    if (!operation.targets.some((target) => sourceFileKey(target.absolutePath) === fileKey))
      continue;
    if (operation.result === null) {
      const previous = operation.receivedSourceVersions.get(fileKey);
      if (previous?.sessionId !== sourceVersion.sessionId || previous.revision < sourceVersion.revision)
        operation.receivedSourceVersions.set(fileKey, sourceVersion);
      continue;
    }
    const written = operation.result.sourceVersions.get(fileKey);
    if (written && written.sessionId === sourceVersion.sessionId && sourceVersion.revision > written.revision)
      remove(operation);
  }
};

// src/helpers/effect-deletion-state.ts
import { useCallback as useCallback2 } from "react";
import { Internals as Internals3 } from "remotion";
var getPendingEffectDeletions = () => Internals3.OptimisticEffectDeletion.getSnapshot();
var isEffectDeletionPending = (nodePath) => Internals3.OptimisticEffectDeletion.get(nodePath) !== null;
var usePendingEffectDeletions = () => useSyncExternalStore(Internals3.OptimisticEffectDeletion.subscribe, getPendingEffectDeletions, getPendingEffectDeletions);
var useIsEffectDeletionPending = (nodePath) => {
  const subscribe = useCallback2((listener) => Internals3.OptimisticEffectDeletion.subscribeToNode(nodePath, listener), [nodePath]);
  const getSnapshot = useCallback2(() => isEffectDeletionPending(nodePath), [nodePath]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};
var assertEffectChainEditable = (nodePath) => {
  if (isEffectDeletionPending(nodePath))
    throw new Error("Wait for the effect deletion to finish before editing this effect chain.");
};
var remapOptimisticEffectDeletions = (mutation) => {
  const entries = getPendingEffectDeletions();
  if (entries.length === 0)
    return;
  const byFile = new Map(mutation.files.map((file) => [
    file.absolutePath,
    new Map(file.remappings.filter((item) => item.oldNodePath !== null).map((item) => [JSON.stringify(item.oldNodePath), item]))
  ]));
  Internals3.OptimisticEffectDeletion.remap(entries.map((entry) => {
    const path = entry.nodePath.nodePath;
    const mappings = byFile.get(entry.nodePath.absolutePath);
    let oldLength = path.length;
    let remapping = mappings?.get(JSON.stringify(path));
    while (!remapping && oldLength > 1) {
      oldLength--;
      remapping = mappings?.get(JSON.stringify([...path.slice(0, oldLength - 1), "openingElement"]));
    }
    if (!remapping)
      return { entry, nodePath: entry.nodePath };
    return {
      entry,
      nodePath: remapping.newNodePath === null ? null : {
        ...entry.nodePath,
        nodePath: oldLength === path.length ? remapping.newNodePath : [
          ...remapping.newNodePath.slice(0, -1),
          ...path.slice(oldLength - 1)
        ]
      }
    };
  }));
};
var selectionRevision = 0;
var getEffectDeletionSelectionRevision = () => selectionRevision;
var invalidateEffectDeletionSelection = () => selectionRevision++;

// src/helpers/guard-pending-effect-deletion.ts
var authorizedDeletions = new WeakSet;
var authorizeEffectDeletionRequest = (request) => {
  authorizedDeletions.add(request);
};
var guardPendingEffectDeletion = (endpoint, body) => {
  if (endpoint === "/api/delete-effect" && typeof body === "object" && body !== null && authorizedDeletions.has(body))
    return;
  const object = body;
  let targets = [];
  switch (endpoint) {
    case "/api/add-effect":
    case "/api/reorder-effect":
    case "/api/save-effect-props":
    case "/api/add-effect-keyframe":
    case "/api/update-effect-keyframe-settings":
      targets = [body];
      break;
    case "/api/delete-effect":
    case "/api/duplicate-effect":
      targets = body;
      break;
    case "/api/paste-effects":
      targets = [{ sequenceNodePath: object.targetSequenceNodePath }];
      break;
    case "/api/save-multiple-effect-props":
      targets = object.edits;
      break;
    case "/api/save-sequence-props":
      targets = object.movedKeyframes?.effectKeyframes ?? [];
      break;
    case "/api/add-keyframes":
    case "/api/delete-keyframes":
    case "/api/move-keyframes":
    case "/api/batch-update-keyframe-settings":
      targets = object.effectKeyframes;
      break;
    default:
      return;
  }
  for (const target of targets ?? []) {
    const nodePath = target.sequenceNodePath;
    if (nodePath)
      assertEffectChainEditable(nodePath);
  }
};

// src/api/install-package.ts
import { getRemotionEnvironment } from "remotion";

// src/helpers/browser-studio-operations.ts
import {
  studioOperations
} from "@remotion/studio-shared";
var queuedOperations = new WeakMap;
var withMutationQueue = (operations) => {
  const existing = queuedOperations.get(operations);
  if (existing) {
    return existing;
  }
  const methods = new Map;
  const wrapped = new Proxy(operations, {
    get(target, property, receiver) {
      const value = Reflect.get(target, property, receiver);
      if (property === "effects" || property === "keyframes") {
        return value ? withMutationQueue(value) : value;
      }
      if (typeof property !== "string" || typeof value !== "function") {
        return value;
      }
      const cached = methods.get(property);
      if (cached?.original === value) {
        return cached.queued;
      }
      const name = property === "deleteEffects" ? "deleteEffect" : property === "duplicateEffects" ? "duplicateEffect" : property;
      const endpoint = `/api/${name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}`;
      const queued = studioOperations[endpoint]?.mutatesSource ? (...args) => enqueueStudioSourceMutation(endpoint, args[0], (rebasedBody) => value.apply(target, [rebasedBody, ...args.slice(1)])) : property === "subscribeToSequenceProps" ? (...args) => {
        return withSequenceSourceRead([args[0].fileName], () => value.apply(target, args));
      } : value.bind(target);
      methods.set(property, { original: value, queued });
      return queued;
    }
  });
  queuedOperations.set(operations, wrapped);
  return wrapped;
};
var BROWSER_STUDIO_OPERATIONS_READY_EVENT = "remotion-browser-studio-operations-ready";
var getBrowserStudioOperations = () => {
  if (typeof window === "undefined") {
    return null;
  }
  return window.remotion_browserStudio ? withMutationQueue(window.remotion_browserStudio) : null;
};
var getBrowserStudioKeyframeOperations = () => getBrowserStudioOperations()?.keyframes ?? null;
var getBrowserStudioEffectOperations = () => getBrowserStudioOperations()?.effects ?? null;
var canUseKeyframeOperations = () => !window.remotion_isReadOnlyStudio || getBrowserStudioKeyframeOperations() !== null;
var canUseEffectOperations = () => !window.remotion_isReadOnlyStudio || getBrowserStudioEffectOperations() !== null;
var canInstallPackages = () => {
  const browserStudioOperations = getBrowserStudioOperations();
  if (browserStudioOperations !== null) {
    return true;
  }
  return !window.remotion_isReadOnlyStudio;
};

// src/helpers/optional-package-dependencies.ts
import { extraPackages } from "@remotion/studio-shared";
var TRANSFORMERS_PACKAGE = "@huggingface/transformers";
var packagesRequiringTransformers = new Set([
  "@remotion/whisper-webgpu",
  "@remotion/video-matting"
]);
var withRequiredAuxiliaryPackages = (dependencies) => {
  if (!dependencies.some((dependency) => packagesRequiringTransformers.has(dependency.name)) || dependencies.some((dependency) => dependency.name === TRANSFORMERS_PACKAGE)) {
    return [...dependencies];
  }
  const transformers = extraPackages.find((pkg) => pkg.name === TRANSFORMERS_PACKAGE);
  if (!transformers) {
    throw new Error(`No recommended version found for ${TRANSFORMERS_PACKAGE}`);
  }
  return [
    ...dependencies,
    { name: transformers.name, version: transformers.version }
  ];
};

// src/api/install-package.ts
var installPackages = async (dependencies) => {
  if (!getRemotionEnvironment().isStudio) {
    throw new Error("installPackages() is only available in the Studio");
  }
  const dependenciesWithAuxiliaryPackages = withRequiredAuxiliaryPackages(dependencies);
  const browserStudioOperations = getBrowserStudioOperations();
  if (browserStudioOperations !== null) {
    const response = await browserStudioOperations.packageInstallation.installPackages({
      dependencies: dependenciesWithAuxiliaryPackages
    });
    if (!response.success) {
      const error = new Error(response.reason);
      error.stack = response.stack;
      throw error;
    }
    return {};
  }
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("installPackages() is not available in Read-Only Studio");
  }
  return callApi("/api/install-package", {
    dependencies: dependenciesWithAuxiliaryPackages
  });
};

// src/components/Notifications/NotificationCenter.tsx
import {
  createRef,
  useCallback as useCallback6,
  useImperativeHandle,
  useState as useState3
} from "react";
import ReactDOM from "react-dom";

// src/state/z-index.tsx
import {
  createContext as createContext3,
  useContext as useContext2,
  useLayoutEffect,
  useMemo as useMemo5,
  useRef as useRef2
} from "react";

// src/helpers/pointer-session.ts
import { CanvasInternals } from "@remotion/sdk";
var {
  isPointerSessionRelease,
  observePointerRelease,
  startCapturedPointerSession,
  startDeferredCapturedPointerSession
} = CanvasInternals;

// src/helpers/use-keybinding.ts
import { useCallback as useCallback4, useContext, useEffect, useMemo as useMemo3, useState } from "react";

// src/helpers/is-mac.ts
var isMac = typeof window !== "undefined" && window.navigator.platform.startsWith("Mac");

// src/helpers/studio-runtime-config.ts
import { NoReactInternals } from "remotion/no-react";
var DEFAULT_BUFFER_STATE_DELAY_IN_MILLISECONDS = 300;
var defaultStudioRuntimeConfig = {
  preferredEffectBackend: null,
  preservePitchOnPlayback: true,
  showLayerFrameNumbers: false,
  showPremounting: null,
  defaultPremountInSeconds: null,
  askAIEnabled: false,
  sequenceActivityLimit: null,
  bufferStateDelayInMilliseconds: null,
  defaultCodingAgent: null,
  defaultEditor: null,
  interactivityEnabled: true,
  keyboardShortcutsEnabled: true,
  maxTimelineTracks: null,
  publicLicenseKey: null,
  canvasTabsEnabled: true,
  configFileStudioSettings: null
};
var getStudioRuntimeConfig = () => {
  if (typeof window === "undefined") {
    return defaultStudioRuntimeConfig;
  }
  return window.remotion_studioConfig ?? defaultStudioRuntimeConfig;
};
var getStudioAskAIEnabled = () => {
  return getStudioRuntimeConfig().askAIEnabled;
};
var getStudioInteractivityEnabled = () => {
  return getStudioRuntimeConfig().interactivityEnabled;
};
var getStudioKeyboardShortcutsEnabled = () => {
  return getStudioRuntimeConfig().keyboardShortcutsEnabled;
};
var getStudioKeyboardShortcuts = () => {
  return getStudioRuntimeConfig().keyboardShortcuts ?? null;
};
var getStudioMaxTimelineTracks = () => {
  return getStudioRuntimeConfig().maxTimelineTracks;
};
var getStudioBufferStateDelayInMilliseconds = () => {
  return getStudioRuntimeConfig().bufferStateDelayInMilliseconds ?? DEFAULT_BUFFER_STATE_DELAY_IN_MILLISECONDS;
};
var getStudioDefaultPremountInSeconds = () => {
  return getStudioRuntimeConfig().defaultPremountInSeconds ?? NoReactInternals.DEFAULT_STUDIO_PREMOUNT_IN_SECONDS;
};
var getStudioShowPremounting = () => {
  return getStudioRuntimeConfig().showPremounting ?? false;
};
var getStudioShowLayerFrameNumbers = () => {
  return getStudioRuntimeConfig().showLayerFrameNumbers;
};
var getStudioSequenceActivitySettings = () => {
  const config = getStudioRuntimeConfig();
  return {
    limit: config.sequenceActivityLimit ?? NoReactInternals.DEFAULT_SEQUENCE_ACTIVITY_LIMIT
  };
};

// src/components/keyboard-shortcuts.ts
var shortcut = (action, actionId) => ({ action, actionId });
var fixedShortcut = (action, fixedChords, fixedReason) => ({ action, actionId: null, fixedChords, fixedReason });
var defaultKeyboardShortcuts = {
  playPause: [{ key: "Space" }],
  toggleMute: [{ key: "m", shift: false }],
  toggleLoop: [{ key: "l", shift: true }],
  jumpToBeginning: [{ key: "a" }],
  jumpToEnd: [{ key: "e" }],
  reversePlayback: [{ key: "j" }],
  pausePlayback: [{ key: "k" }],
  playForward: [{ key: "l", shift: false }],
  decreasePlaybackRate: [{ key: "<" }],
  increasePlaybackRate: [{ key: ">" }],
  goToFrame: [{ key: "g" }],
  pauseAndReturnToPlaybackStart: [{ key: "Enter" }],
  toggleLeftSidebar: [{ key: "b", commandOrControl: true }],
  toggleRightSidebar: [{ key: "j", commandOrControl: true }],
  toggleBothSidebars: [{ key: "g", commandOrControl: true }],
  enterFullscreen: [{ key: "f" }],
  toggleSnapping: [{ key: "m", shift: true }],
  toggleOutlines: [{ key: "o", shift: true }],
  toggleRulersAndGuides: [{ key: "r", shift: true }],
  togglePixelGrid: [{ key: "p", shift: true }],
  previousComposition: [{ key: "PageUp" }],
  nextComposition: [{ key: "PageDown" }],
  newComposition: [{ key: "n" }],
  showKeyboardShortcuts: [{ key: "?", shift: true }],
  quickSwitcher: [{ key: "k", commandOrControl: true }],
  render: [{ key: "r", shift: false }],
  toggleCheckerboard: [{ key: "t" }],
  setInPoint: [{ key: "i" }],
  setOutPoint: [{ key: "o", shift: false }],
  clearInOutPoints: [{ key: "x" }],
  zoomIn: [{ key: "+", shift: true }, { key: "+" }],
  zoomOut: [{ key: "-" }],
  resetZoom: [{ key: "0" }],
  undo: [{ key: "z", commandOrControl: true, shift: false }],
  redo: [
    ...isMac ? [] : [{ key: "y", commandOrControl: true }],
    { key: "z", commandOrControl: true, shift: true }
  ],
  selectAllSequenceRows: [{ key: "a", commandOrControl: true }],
  selectTranslateProp: [{ key: "p", shift: false }],
  selectOpacityProp: [{ key: "t" }],
  selectRotateProp: [{ key: "r", shift: false }],
  selectScaleProp: [{ key: "s" }],
  selectVolumeProp: [{ key: "v" }],
  duplicateSequences: [{ key: "d", commandOrControl: true, shift: false }],
  splitSequences: [{ key: "d", commandOrControl: true, shift: true }],
  copyEffectsAndValues: [{ key: "c", commandOrControl: true }],
  cutEffects: [{ key: "x", commandOrControl: true }],
  deleteSelection: [{ key: "Backspace" }, { key: "Delete" }],
  askAI: [{ key: "i", commandOrControl: true }],
  pickColor: [{ key: "c", shift: true }]
};
var keyboardShortcutGroups = [
  {
    name: "Playback",
    shortcuts: [
      fixedShortcut("1 second back", [["Shift", "←"]], "Context-sensitive timeline control"),
      fixedShortcut("Previous frame", [["←"]], "Context-sensitive timeline control"),
      shortcut("Play / Pause", "playPause"),
      shortcut("Mute / Unmute", "toggleMute"),
      shortcut("Loop", "toggleLoop"),
      fixedShortcut("Next frame", [["→"]], "Context-sensitive timeline control"),
      fixedShortcut("1 second forward", [["Shift", "→"]], "Context-sensitive timeline control"),
      shortcut("Jump to beginning", "jumpToBeginning"),
      shortcut("Jump to end", "jumpToEnd"),
      shortcut("Reverse playback", "reversePlayback"),
      shortcut("Pause", "pausePlayback"),
      shortcut("Play / Speed up", "playForward"),
      shortcut("Decrease playback rate", "decreasePlaybackRate"),
      shortcut("Increase playback rate", "increasePlaybackRate"),
      shortcut("Go to frame", "goToFrame"),
      shortcut("Pause & return to playback start", "pauseAndReturnToPlaybackStart")
    ]
  },
  {
    name: "Sidebar",
    shortcuts: [
      shortcut("Toggle left sidebar", "toggleLeftSidebar"),
      shortcut("Toggle right sidebar", "toggleRightSidebar"),
      shortcut("Toggle both sidebars", "toggleBothSidebars")
    ]
  },
  {
    name: "View",
    shortcuts: [
      shortcut("Enter fullscreen", "enterFullscreen"),
      fixedShortcut("Exit fullscreen", [["Esc"]], "Handled by the browser"),
      shortcut("Enable snapping", "toggleSnapping"),
      shortcut("Outlines", "toggleOutlines"),
      shortcut("Rulers and guides", "toggleRulersAndGuides"),
      shortcut("Pixel grid", "togglePixelGrid")
    ]
  },
  {
    name: "Navigation",
    shortcuts: [
      shortcut("Previous composition", "previousComposition"),
      shortcut("Next composition", "nextComposition"),
      shortcut("New composition", "newComposition"),
      shortcut("Render, unless a sequence or prop is selected", "render"),
      shortcut("Checkerboard, unless a sequence or prop is selected", "toggleCheckerboard"),
      shortcut("Show keyboard shortcuts", "showKeyboardShortcuts"),
      shortcut("Quick Switcher", "quickSwitcher")
    ]
  },
  {
    name: "Playback range",
    shortcuts: [
      shortcut("Set In Point", "setInPoint"),
      shortcut("Set Out Point", "setOutPoint"),
      shortcut("Clear In/Out Points", "clearInOutPoints")
    ]
  },
  {
    name: "Zoom",
    shortcuts: [
      shortcut("Zoom in", "zoomIn"),
      shortcut("Zoom out", "zoomOut"),
      shortcut("Reset zoom", "resetZoom")
    ]
  },
  {
    name: "Tools",
    shortcuts: [shortcut("Color Picker", "pickColor")]
  },
  {
    name: "Props Editor",
    shortcuts: [shortcut("Undo", "undo"), shortcut("Redo", "redo")]
  },
  {
    name: "Interactivity",
    shortcuts: [
      fixedShortcut("Select range / axis lock drag", [["Shift"]], "Gesture modifier"),
      fixedShortcut("Toggle selection", [[isMac ? "⌘" : "Ctrl"]], "Gesture modifier"),
      shortcut("Select sequence rows", "selectAllSequenceRows"),
      shortcut("Select translate prop", "selectTranslateProp"),
      shortcut("Select opacity prop", "selectOpacityProp"),
      shortcut("Select rotate prop", "selectRotateProp"),
      shortcut("Select scale prop", "selectScaleProp"),
      shortcut("Select volume prop", "selectVolumeProp"),
      shortcut("Duplicate sequences", "duplicateSequences"),
      shortcut("Split sequences at playhead", "splitSequences"),
      shortcut("Copy effects / values", "copyEffectsAndValues"),
      shortcut("Cut effects", "cutEffects"),
      fixedShortcut("Paste effects / values", [[isMac ? "⌘" : "Ctrl", "V"]], "Handled by the browser clipboard event"),
      shortcut("Delete / reset selection", "deleteSelection")
    ]
  }
];
var askAIKeyboardShortcutGroup = {
  name: "AI",
  shortcuts: [shortcut("Ask AI", "askAI")]
};
var getKeyboardShortcutsForAction = (action, configured = getStudioKeyboardShortcuts()) => {
  if (configured !== null && Object.prototype.hasOwnProperty.call(configured, action)) {
    const value = configured[action];
    if (value === null) {
      return [];
    }
    return Array.isArray(value) ? value : [
      value
    ];
  }
  return defaultKeyboardShortcuts[action];
};
var normalizeKey = (key) => key === "Space" ? " " : key;
var keyboardEventMatchesShortcut = ({
  event,
  shortcut: value
}) => {
  const commandOrControl = isMac ? event.metaKey : event.ctrlKey;
  return event.key.toLowerCase() === normalizeKey(value.key).toLowerCase() && commandOrControl === (value.commandOrControl ?? false) && (isMac ? !event.ctrlKey : !event.metaKey) && (value.shift === undefined || event.shiftKey === value.shift) && (value.alt === undefined || event.altKey === value.alt);
};
var keyboardShortcutsOverlap = (first, second) => first.key.toLowerCase() === second.key.toLowerCase() && (first.commandOrControl ?? false) === (second.commandOrControl ?? false) && (first.shift === undefined || second.shift === undefined || first.shift === second.shift) && (first.alt === undefined || second.alt === undefined || first.alt === second.alt);
var keyboardEventMatchesAction = (event, action) => getKeyboardShortcutsForAction(action).some((value) => keyboardEventMatchesShortcut({ event, shortcut: value }));
var displayKey = (keyboardKey) => {
  if (keyboardKey === "ArrowLeft")
    return "←";
  if (keyboardKey === "ArrowRight")
    return "→";
  if (keyboardKey === "Delete")
    return "Del";
  if (keyboardKey === "Backspace")
    return "⌫";
  if (keyboardKey === "Escape")
    return "Esc";
  return keyboardKey.length === 1 ? keyboardKey.toUpperCase() : keyboardKey;
};
var formatKeyboardShortcut = (value) => [
  ...value.commandOrControl ? [isMac ? "⌘" : "Ctrl"] : [],
  ...value.alt ? [isMac ? "Option" : "Alt"] : [],
  ...value.shift && !["+", "?"].includes(value.key) ? ["Shift"] : [],
  displayKey(value.key)
];
var formatKeyboardShortcutForAria = (value) => [
  ...value.commandOrControl ? [isMac ? "Meta" : "Control"] : [],
  ...value.alt ? ["Alt"] : [],
  ...value.shift ? ["Shift"] : [],
  value.key
].join("+");
var getKeyboardShortcutLabel = (action) => getKeyboardShortcutsForAction(action).map((value) => formatKeyboardShortcut(value).join("+")).join(" / ");
var getKeyboardShortcutAriaKeyShortcuts = (action) => getKeyboardShortcutsForAction(action).map(formatKeyboardShortcutForAria).join(" ");
var shortcutFromKeyboardEvent = (event) => {
  if (["Alt", "Control", "Meta", "Shift"].includes(event.key)) {
    return null;
  }
  if (isMac ? event.ctrlKey : event.metaKey) {
    return null;
  }
  return {
    key: event.key === " " ? "Space" : event.key,
    ...(isMac ? event.metaKey : event.ctrlKey) ? { commandOrControl: true } : {},
    shift: event.shiftKey,
    alt: event.altKey
  };
};

// src/state/keybindings.tsx
import { createContext, useCallback as useCallback3, useMemo as useMemo2, useRef } from "react";
import { jsx as jsx7 } from "react/jsx-runtime";
var KeybindingContext = createContext({
  registerKeybinding: () => {
    throw new Error("Has no keybinding context");
  },
  unregisterKeybinding: () => {
    return;
  },
  unregisterPane: () => {
    return;
  }
});
var KeybindingContextProvider = ({ children }) => {
  const registered = useRef([]);
  const registerKeybinding = useCallback3((binding) => {
    registered.current = [...registered.current, binding];
    window.addEventListener(binding.event, binding.callback);
  }, []);
  const unregisterKeybinding = useCallback3((binding) => {
    registered.current = registered.current.filter((r) => {
      if (r.id === binding.id) {
        window.removeEventListener(binding.event, binding.callback);
        return false;
      }
      return true;
    });
  }, []);
  const unregisterPane = useCallback3((paneId) => {
    const matchedKeybindings = registered.current.filter((r) => r.registeredFromPane === paneId);
    for (const matched of matchedKeybindings) {
      unregisterKeybinding(matched);
    }
  }, [unregisterKeybinding]);
  const value = useMemo2(() => {
    return {
      registerKeybinding,
      unregisterKeybinding,
      unregisterPane
    };
  }, [registerKeybinding, unregisterKeybinding, unregisterPane]);
  return /* @__PURE__ */ jsx7(KeybindingContext.Provider, {
    value,
    children
  });
};

// src/helpers/use-keybinding.ts
if (!getStudioKeyboardShortcutsEnabled()) {
  console.warn("Keyboard shortcuts disabled either due to: a) --disable-keyboard-shortcuts being passed b) Config.setKeyboardShortcutsEnabled(false) being set or c) a Remotion version mismatch.");
}
var areKeyboardShortcutsDisabled = () => {
  return !getStudioKeyboardShortcutsEnabled();
};
var useKeybinding = () => {
  const [paneId] = useState(() => String(Math.random()));
  const context = useContext(KeybindingContext);
  const { isHighestContext } = useZIndex();
  const registerKeybinding = useCallback4((options) => {
    if (!isHighestContext && !options.keepRegisteredWhenNotHighestContext) {
      return {
        unregister: () => {
          return;
        }
      };
    }
    const listener = (e) => {
      if (!e.key) {
        return;
      }
      const matches = options.action ? keyboardEventMatchesAction(e, options.action) : e.key.toLowerCase() === options.key.toLowerCase() && options.commandCtrlKey === (isMac ? e.metaKey : e.ctrlKey);
      if (matches && getStudioKeyboardShortcutsEnabled()) {
        if (!options.triggerIfInputFieldFocused) {
          const { activeElement } = document;
          if (activeElement instanceof HTMLInputElement) {
            return;
          }
          if (activeElement instanceof HTMLTextAreaElement) {
            return;
          }
        }
        options.callback(e);
        if (options.preventDefault) {
          e.preventDefault();
        }
      }
    };
    const toRegister = {
      registeredFromPane: paneId,
      event: options.event,
      key: options.action ?? options.key,
      callback: listener,
      id: String(Math.random())
    };
    context.registerKeybinding(toRegister);
    return {
      unregister: () => context.unregisterKeybinding(toRegister)
    };
  }, [context, isHighestContext, paneId]);
  useEffect(() => {
    return () => {
      context.unregisterPane(paneId);
    };
  }, [context, paneId]);
  return useMemo3(() => ({ registerKeybinding, isHighestContext }), [registerKeybinding, isHighestContext]);
};

// src/state/highest-z-index.tsx
import { createContext as createContext2, useCallback as useCallback5, useMemo as useMemo4, useState as useState2 } from "react";
import { jsx as jsx8 } from "react/jsx-runtime";
var HighestZIndexContext = createContext2({
  highestIndex: 0,
  registerZIndex: () => {
    return;
  },
  unregisterZIndex: () => {
    return;
  }
});
var HighestZIndexProvider = ({ children }) => {
  const [zIndexes, setZIndexes] = useState2([]);
  const registerZIndex = useCallback5((newIndex) => {
    setZIndexes((prev) => [...prev, newIndex]);
  }, []);
  const unregisterZIndex = useCallback5((newIndex) => {
    setZIndexes((prev) => {
      const index = prev.indexOf(newIndex);
      if (index === -1) {
        throw new Error("did not find z-index " + newIndex);
      }
      return prev.filter((_n, i) => i !== index);
    });
  }, []);
  const highestIndex = Math.max(...zIndexes);
  const value = useMemo4(() => {
    return {
      highestIndex,
      registerZIndex,
      unregisterZIndex
    };
  }, [registerZIndex, unregisterZIndex, highestIndex]);
  return /* @__PURE__ */ jsx8(HighestZIndexContext.Provider, {
    value,
    children
  });
};

// src/state/input-dragger-click-lock.ts
var clickLock = false;
var getClickLock = () => clickLock;
var setClickLock = (lock) => {
  clickLock = lock;
};

// src/state/z-index.tsx
import { jsx as jsx9, jsxs as jsxs2 } from "react/jsx-runtime";
var ZIndexContext = createContext3({
  currentIndex: 0
});
var margin = {
  margin: "auto"
};
var EscapeHook = ({ onEscape }) => {
  const keybindings = useKeybinding();
  useLayoutEffect(() => {
    const escape = keybindings.registerKeybinding({
      event: "keydown",
      key: "Escape",
      callback: onEscape,
      commandCtrlKey: false,
      preventDefault: true,
      triggerIfInputFieldFocused: true,
      keepRegisteredWhenNotHighestContext: false
    });
    return () => {
      escape.unregister();
    };
  }, [keybindings, onEscape]);
  return null;
};
var HigherZIndex = ({
  children,
  onEscape,
  onOutsideClick,
  disabled,
  outsideClickButton = "any"
}) => {
  const context = useContext2(ZIndexContext);
  const highestContext = useContext2(HighestZIndexContext);
  const { registerZIndex, unregisterZIndex } = highestContext;
  const containerRef = useRef2(null);
  const highestIndexRef = useRef2(highestContext.highestIndex);
  const onOutsideClickRef = useRef2(onOutsideClick);
  const outsideClickButtonRef = useRef2(outsideClickButton);
  const currentIndex = disabled ? context.currentIndex : context.currentIndex + 1;
  useLayoutEffect(() => {
    highestIndexRef.current = highestContext.highestIndex;
    onOutsideClickRef.current = onOutsideClick;
    outsideClickButtonRef.current = outsideClickButton;
  }, [highestContext.highestIndex, onOutsideClick, outsideClickButton]);
  useLayoutEffect(() => {
    if (disabled) {
      return;
    }
    registerZIndex(currentIndex);
    return () => unregisterZIndex(currentIndex);
  }, [currentIndex, disabled, registerZIndex, unregisterZIndex]);
  useLayoutEffect(() => {
    if (disabled) {
      return;
    }
    let endPointerSession = null;
    const listener = (downEvent) => {
      if (outsideClickButtonRef.current === "primary" && downEvent.button !== 0) {
        return;
      }
      const outsideClick = !containerRef.current?.contains(downEvent.target);
      if (!outsideClick) {
        return;
      }
      if (highestIndexRef.current !== currentIndex) {
        return;
      }
      endPointerSession?.();
      endPointerSession = observePointerRelease({
        event: downEvent,
        onEnd: (reason, upEvent) => {
          endPointerSession = null;
          if (isPointerSessionRelease(reason, upEvent) && !getClickLock()) {
            const target = document.elementFromPoint(upEvent.clientX, upEvent.clientY) ?? upEvent.target;
            if (document.contains(target)) {
              upEvent.stopPropagation();
              onOutsideClickRef.current(target);
            }
          }
        }
      });
    };
    window.addEventListener("pointerdown", listener, true);
    return () => {
      endPointerSession?.();
      endPointerSession = null;
      return window.removeEventListener("pointerdown", listener, true);
    };
  }, [currentIndex, disabled]);
  const value = useMemo5(() => {
    return {
      currentIndex
    };
  }, [currentIndex]);
  return /* @__PURE__ */ jsxs2(ZIndexContext.Provider, {
    value,
    children: [
      disabled ? null : /* @__PURE__ */ jsx9(EscapeHook, {
        onEscape
      }),
      /* @__PURE__ */ jsx9("div", {
        ref: containerRef,
        style: margin,
        children
      })
    ]
  });
};
var useZIndex = () => {
  const context = useContext2(ZIndexContext);
  const highestContext = useContext2(HighestZIndexContext);
  const isHighestContext = highestContext.highestIndex === context.currentIndex;
  return useMemo5(() => ({
    currentZIndex: context.currentIndex,
    highestZIndex: highestContext.highestIndex,
    isHighestContext,
    tabIndex: isHighestContext ? 0 : -1
  }), [context.currentIndex, highestContext.highestIndex, isHighestContext]);
};

// src/components/Menu/portals.ts
var portalIds = [
  "menuportal-0",
  "menuportal-1",
  "menuportal-2",
  "menuportal-3",
  "menuportal-4",
  "menuportal-5"
];
var portals = typeof document === "undefined" ? [] : portalIds.map((id) => document.getElementById(id));
var getPortal = (i) => {
  const portal = portals[i];
  if (!portal) {
    throw new Error(`Expected menu portal ${i} to exist`);
  }
  return portal;
};

// src/components/Notifications/Notification.tsx
import { useEffect as useEffect2 } from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
var notification = {
  backgroundColor: NOTIFICATION_BACKGROUND,
  color: WHITE_HEX,
  fontFamily: "Arial, Helvetica, sans-serif",
  display: "inline-flex",
  padding: "6px 14px",
  borderRadius: 6,
  fontSize: 13,
  border: NOTIFICATION_BORDER,
  boxShadow: NOTIFICATION_SHADOW,
  marginTop: 3,
  marginBottom: 3,
  alignItems: "center"
};
var Notification = ({ children, id, duration, created, onRemove }) => {
  useEffect2(() => {
    if (duration === null) {
      return;
    }
    const timeout = setTimeout(() => {
      onRemove(id);
    }, duration - (Date.now() - created));
    return () => {
      clearTimeout(timeout);
    };
  }, [created, duration, id, onRemove]);
  return /* @__PURE__ */ jsx10("div", {
    className: "css-reset",
    style: notification,
    children
  });
};

// src/components/Notifications/NotificationCenter.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var container = {
  position: "absolute",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  width: "100%",
  flexDirection: "column",
  paddingTop: 40,
  pointerEvents: "none",
  backgroundColor: TRANSPARENT
};
var notificationCenter = createRef();
var showNotification = (content, durationInMs) => {
  return notificationCenter.current.addNotification({
    content,
    duration: durationInMs,
    created: Date.now(),
    id: String(Math.random()).replace("0.", "")
  });
};
var NotificationCenter = () => {
  const [notifications, setNotifications] = useState3([]);
  const { currentZIndex } = useZIndex();
  const onRemove = useCallback6((id) => {
    setNotifications((not) => {
      return not.filter((n) => n.id !== id);
    });
  }, []);
  const addNotification = useCallback6((notification) => {
    setNotifications((previousNotifications) => {
      return [...previousNotifications, notification];
    });
    return {
      dismiss: () => {
        setNotifications((oldNotifications) => {
          return oldNotifications.filter((notificationToFilter) => notificationToFilter.id !== notification.id);
        });
      },
      replaceContent: (newContent, durationInMs) => {
        setNotifications((oldNotifications) => {
          return oldNotifications.map((notificationToMap) => {
            if (notificationToMap.id === notification.id) {
              return {
                ...notificationToMap,
                duration: durationInMs,
                content: newContent,
                created: Date.now()
              };
            }
            return notificationToMap;
          });
        });
      }
    };
  }, []);
  useImperativeHandle(notificationCenter, () => {
    return {
      addNotification
    };
  }, [addNotification]);
  return ReactDOM.createPortal(/* @__PURE__ */ jsx11("div", {
    style: container,
    children: notifications.map((n) => {
      return /* @__PURE__ */ jsx11(Notification, {
        created: n.created,
        duration: n.duration,
        id: n.id,
        onRemove,
        children: n.content
      }, n.id);
    })
  }), getPortal(currentZIndex + 1));
};

// src/helpers/install-required-package.ts
var installQueue = Promise.resolve();
var uniqueDependencies = (dependencies) => Array.from(new Map(dependencies.map((dependency) => [dependency.name, dependency])).values());
var getMissingPackages = (dependencies) => {
  const installedPackages = window.remotion_installedPackages ?? [];
  return uniqueDependencies(dependencies).filter((dependency) => dependency.version !== null || !installedPackages.includes(dependency.name));
};
var addInstalledPackages = (dependencies) => {
  const installedPackages = window.remotion_installedPackages ?? [];
  window.remotion_installedPackages = Array.from(new Set([
    ...installedPackages,
    ...uniqueDependencies(dependencies).map((dependency) => dependency.name)
  ]));
};
var formatPackageList = (dependencies) => dependencies.length === 1 ? dependencies[0].name : `${dependencies.length} packages`;
var installRequiredPackages = async (dependencies) => {
  const runInstall = async () => {
    const missingPackages = getMissingPackages(dependencies);
    if (missingPackages.length === 0)
      return;
    showNotification(`Installing ${formatPackageList(missingPackages)}...`, 3000);
    await installPackages(missingPackages);
    addInstalledPackages(missingPackages);
    showNotification(`Installed ${formatPackageList(missingPackages)}`, 3000);
  };
  const queuedInstall = installQueue.then(runInstall, runInstall);
  installQueue = queuedInstall.catch(() => {
    return;
  });
  await queuedInstall;
};

// src/components/Timeline/google-fonts-list.ts
var GOOGLE_FONTS_LIST = [
  {
    importName: "ABeeZee",
    fontFamily: "ABeeZee",
    previewUrl: "ABeeZee",
    weights: ["400"]
  },
  {
    importName: "Abel",
    fontFamily: "Abel",
    previewUrl: "Abel",
    weights: ["400"]
  },
  {
    importName: "AbrilFatface",
    fontFamily: "Abril Fatface",
    previewUrl: "Abril+Fatface",
    weights: ["400"]
  },
  {
    importName: "Acme",
    fontFamily: "Acme",
    previewUrl: "Acme",
    weights: ["400"]
  },
  {
    importName: "Alata",
    fontFamily: "Alata",
    previewUrl: "Alata",
    weights: ["400"]
  },
  {
    importName: "AlbertSans",
    fontFamily: "Albert Sans",
    previewUrl: "Albert+Sans",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Alegreya",
    fontFamily: "Alegreya",
    previewUrl: "Alegreya",
    weights: ["400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "AlegreyaSans",
    fontFamily: "Alegreya Sans",
    previewUrl: "Alegreya+Sans",
    weights: ["100", "300", "400", "500", "700", "800", "900"]
  },
  {
    importName: "AlegreyaSansSC",
    fontFamily: "Alegreya Sans SC",
    previewUrl: "Alegreya+Sans+SC",
    weights: ["100", "300", "400", "500", "700", "800", "900"]
  },
  {
    importName: "AlfaSlabOne",
    fontFamily: "Alfa Slab One",
    previewUrl: "Alfa+Slab+One",
    weights: ["400"]
  },
  {
    importName: "Alice",
    fontFamily: "Alice",
    previewUrl: "Alice",
    weights: ["400"]
  },
  {
    importName: "Almarai",
    fontFamily: "Almarai",
    previewUrl: "Almarai",
    weights: ["300", "400", "700", "800"]
  },
  {
    importName: "AmaticSC",
    fontFamily: "Amatic SC",
    previewUrl: "Amatic+SC",
    weights: ["400", "700"]
  },
  {
    importName: "Amiri",
    fontFamily: "Amiri",
    previewUrl: "Amiri",
    weights: ["400", "700"]
  },
  {
    importName: "AnticSlab",
    fontFamily: "Antic Slab",
    previewUrl: "Antic+Slab",
    weights: ["400"]
  },
  {
    importName: "Anton",
    fontFamily: "Anton",
    previewUrl: "Anton",
    weights: ["400"]
  },
  {
    importName: "ArchitectsDaughter",
    fontFamily: "Architects Daughter",
    previewUrl: "Architects+Daughter",
    weights: ["400"]
  },
  {
    importName: "Archivo",
    fontFamily: "Archivo",
    previewUrl: "Archivo",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "ArchivoBlack",
    fontFamily: "Archivo Black",
    previewUrl: "Archivo+Black",
    weights: ["400"]
  },
  {
    importName: "ArchivoNarrow",
    fontFamily: "Archivo Narrow",
    previewUrl: "Archivo+Narrow",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "Arimo",
    fontFamily: "Arimo",
    previewUrl: "Arimo",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "Arsenal",
    fontFamily: "Arsenal",
    previewUrl: "Arsenal",
    weights: ["400", "700"]
  },
  {
    importName: "Arvo",
    fontFamily: "Arvo",
    previewUrl: "Arvo",
    weights: ["400", "700"]
  },
  {
    importName: "Asap",
    fontFamily: "Asap",
    previewUrl: "Asap",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "AsapCondensed",
    fontFamily: "Asap Condensed",
    previewUrl: "Asap+Condensed",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Assistant",
    fontFamily: "Assistant",
    previewUrl: "Assistant",
    weights: ["200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "Barlow",
    fontFamily: "Barlow",
    previewUrl: "Barlow",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "BarlowCondensed",
    fontFamily: "Barlow Condensed",
    previewUrl: "Barlow+Condensed",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "BarlowSemiCondensed",
    fontFamily: "Barlow Semi Condensed",
    previewUrl: "Barlow+Semi+Condensed",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "BeVietnamPro",
    fontFamily: "Be Vietnam Pro",
    previewUrl: "Be+Vietnam+Pro",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "BebasNeue",
    fontFamily: "Bebas Neue",
    previewUrl: "Bebas+Neue",
    weights: ["400"]
  },
  {
    importName: "Bitter",
    fontFamily: "Bitter",
    previewUrl: "Bitter",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "BlackOpsOne",
    fontFamily: "Black Ops One",
    previewUrl: "Black+Ops+One",
    weights: ["400"]
  },
  {
    importName: "BodoniModa",
    fontFamily: "Bodoni Moda",
    previewUrl: "Bodoni+Moda",
    weights: ["400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "BreeSerif",
    fontFamily: "Bree Serif",
    previewUrl: "Bree+Serif",
    weights: ["400"]
  },
  {
    importName: "Bungee",
    fontFamily: "Bungee",
    previewUrl: "Bungee",
    weights: ["400"]
  },
  {
    importName: "Cabin",
    fontFamily: "Cabin",
    previewUrl: "Cabin",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "Cairo",
    fontFamily: "Cairo",
    previewUrl: "Cairo",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Cantarell",
    fontFamily: "Cantarell",
    previewUrl: "Cantarell",
    weights: ["400", "700"]
  },
  {
    importName: "Cardo",
    fontFamily: "Cardo",
    previewUrl: "Cardo",
    weights: ["400", "700"]
  },
  {
    importName: "Catamaran",
    fontFamily: "Catamaran",
    previewUrl: "Catamaran",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Caveat",
    fontFamily: "Caveat",
    previewUrl: "Caveat",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "ChakraPetch",
    fontFamily: "Chakra Petch",
    previewUrl: "Chakra+Petch",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "Changa",
    fontFamily: "Changa",
    previewUrl: "Changa",
    weights: ["200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "Chivo",
    fontFamily: "Chivo",
    previewUrl: "Chivo",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Cinzel",
    fontFamily: "Cinzel",
    previewUrl: "Cinzel",
    weights: ["400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Comfortaa",
    fontFamily: "Comfortaa",
    previewUrl: "Comfortaa",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "Commissioner",
    fontFamily: "Commissioner",
    previewUrl: "Commissioner",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "ConcertOne",
    fontFamily: "Concert One",
    previewUrl: "Concert+One",
    weights: ["400"]
  },
  {
    importName: "Cookie",
    fontFamily: "Cookie",
    previewUrl: "Cookie",
    weights: ["400"]
  },
  {
    importName: "Cormorant",
    fontFamily: "Cormorant",
    previewUrl: "Cormorant",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "CormorantGaramond",
    fontFamily: "Cormorant Garamond",
    previewUrl: "Cormorant+Garamond",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "Courgette",
    fontFamily: "Courgette",
    previewUrl: "Courgette",
    weights: ["400"]
  },
  {
    importName: "CreteRound",
    fontFamily: "Crete Round",
    previewUrl: "Crete+Round",
    weights: ["400"]
  },
  {
    importName: "CrimsonPro",
    fontFamily: "Crimson Pro",
    previewUrl: "Crimson+Pro",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "CrimsonText",
    fontFamily: "Crimson Text",
    previewUrl: "Crimson+Text",
    weights: ["400", "600", "700"]
  },
  {
    importName: "Cuprum",
    fontFamily: "Cuprum",
    previewUrl: "Cuprum",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "DMSans",
    fontFamily: "DM Sans",
    previewUrl: "DM+Sans",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "DMSerifDisplay",
    fontFamily: "DM Serif Display",
    previewUrl: "DM+Serif+Display",
    weights: ["400"]
  },
  {
    importName: "DMSerifText",
    fontFamily: "DM Serif Text",
    previewUrl: "DM+Serif+Text",
    weights: ["400"]
  },
  {
    importName: "DancingScript",
    fontFamily: "Dancing Script",
    previewUrl: "Dancing+Script",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "DidactGothic",
    fontFamily: "Didact Gothic",
    previewUrl: "Didact+Gothic",
    weights: ["400"]
  },
  {
    importName: "Domine",
    fontFamily: "Domine",
    previewUrl: "Domine",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "Dosis",
    fontFamily: "Dosis",
    previewUrl: "Dosis",
    weights: ["200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "EBGaramond",
    fontFamily: "EB Garamond",
    previewUrl: "EB+Garamond",
    weights: ["400", "500", "600", "700", "800"]
  },
  {
    importName: "Eczar",
    fontFamily: "Eczar",
    previewUrl: "Eczar",
    weights: ["400", "500", "600", "700", "800"]
  },
  {
    importName: "ElMessiri",
    fontFamily: "El Messiri",
    previewUrl: "El+Messiri",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "Electrolize",
    fontFamily: "Electrolize",
    previewUrl: "Electrolize",
    weights: ["400"]
  },
  {
    importName: "EncodeSans",
    fontFamily: "Encode Sans",
    previewUrl: "Encode+Sans",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "EncodeSansCondensed",
    fontFamily: "Encode Sans Condensed",
    previewUrl: "Encode+Sans+Condensed",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Exo",
    fontFamily: "Exo",
    previewUrl: "Exo",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Exo2",
    fontFamily: "Exo Two",
    previewUrl: "Exo+2",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Figtree",
    fontFamily: "Figtree",
    previewUrl: "Figtree",
    weights: ["300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "FiraSans",
    fontFamily: "Fira Sans",
    previewUrl: "Fira+Sans",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "FiraSansCondensed",
    fontFamily: "Fira Sans Condensed",
    previewUrl: "Fira+Sans+Condensed",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "FjallaOne",
    fontFamily: "Fjalla One",
    previewUrl: "Fjalla+One",
    weights: ["400"]
  },
  {
    importName: "FrancoisOne",
    fontFamily: "Francois One",
    previewUrl: "Francois+One",
    weights: ["400"]
  },
  {
    importName: "FrankRuhlLibre",
    fontFamily: "Frank Ruhl Libre",
    previewUrl: "Frank+Ruhl+Libre",
    weights: ["300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Fraunces",
    fontFamily: "Fraunces",
    previewUrl: "Fraunces",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Gelasio",
    fontFamily: "Gelasio",
    previewUrl: "Gelasio",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "GloriaHallelujah",
    fontFamily: "Gloria Hallelujah",
    previewUrl: "Gloria+Hallelujah",
    weights: ["400"]
  },
  {
    importName: "GothicA1",
    fontFamily: "Gothic AOne",
    previewUrl: "Gothic+A1",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "GreatVibes",
    fontFamily: "Great Vibes",
    previewUrl: "Great+Vibes",
    weights: ["400"]
  },
  {
    importName: "Gruppo",
    fontFamily: "Gruppo",
    previewUrl: "Gruppo",
    weights: ["400"]
  },
  {
    importName: "Heebo",
    fontFamily: "Heebo",
    previewUrl: "Heebo",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Hind",
    fontFamily: "Hind",
    previewUrl: "Hind",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "HindMadurai",
    fontFamily: "Hind Madurai",
    previewUrl: "Hind+Madurai",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "HindSiliguri",
    fontFamily: "Hind Siliguri",
    previewUrl: "Hind+Siliguri",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "IBMPlexMono",
    fontFamily: "IBM Plex Mono",
    previewUrl: "IBM+Plex+Mono",
    weights: ["100", "200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "IBMPlexSans",
    fontFamily: "IBM Plex Sans",
    previewUrl: "IBM+Plex+Sans",
    weights: ["100", "200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "IBMPlexSansArabic",
    fontFamily: "IBM Plex Sans Arabic",
    previewUrl: "IBM+Plex+Sans+Arabic",
    weights: ["100", "200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "IBMPlexSansCondensed",
    fontFamily: "IBM Plex Sans Condensed",
    previewUrl: "IBM+Plex+Sans+Condensed",
    weights: ["100", "200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "IBMPlexSerif",
    fontFamily: "IBM Plex Serif",
    previewUrl: "IBM+Plex+Serif",
    weights: ["100", "200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "Inconsolata",
    fontFamily: "Inconsolata",
    previewUrl: "Inconsolata",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "IndieFlower",
    fontFamily: "Indie Flower",
    previewUrl: "Indie+Flower",
    weights: ["400"]
  },
  {
    importName: "Inter",
    fontFamily: "Inter",
    previewUrl: "Inter",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "InterTight",
    fontFamily: "Inter Tight",
    previewUrl: "Inter+Tight",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "JosefinSans",
    fontFamily: "Josefin Sans",
    previewUrl: "Josefin+Sans",
    weights: ["100", "200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "JosefinSlab",
    fontFamily: "Josefin Slab",
    previewUrl: "Josefin+Slab",
    weights: ["100", "200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "Jost",
    fontFamily: "Jost",
    previewUrl: "Jost",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Kalam",
    fontFamily: "Kalam",
    previewUrl: "Kalam",
    weights: ["300", "400", "700"]
  },
  {
    importName: "Kanit",
    fontFamily: "Kanit",
    previewUrl: "Kanit",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Karla",
    fontFamily: "Karla",
    previewUrl: "Karla",
    weights: ["200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "KaushanScript",
    fontFamily: "Kaushan Script",
    previewUrl: "Kaushan+Script",
    weights: ["400"]
  },
  {
    importName: "Khand",
    fontFamily: "Khand",
    previewUrl: "Khand",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "Lato",
    fontFamily: "Lato",
    previewUrl: "Lato",
    weights: ["100", "300", "400", "700", "900"]
  },
  {
    importName: "LeagueSpartan",
    fontFamily: "League Spartan",
    previewUrl: "League+Spartan",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Lexend",
    fontFamily: "Lexend",
    previewUrl: "Lexend",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "LexendDeca",
    fontFamily: "Lexend Deca",
    previewUrl: "Lexend+Deca",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "LibreBarcode39",
    fontFamily: "Libre Barcode ThreeNine",
    previewUrl: "Libre+Barcode+39",
    weights: ["400"]
  },
  {
    importName: "LibreBaskerville",
    fontFamily: "Libre Baskerville",
    previewUrl: "Libre+Baskerville",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "LibreCaslonText",
    fontFamily: "Libre Caslon Text",
    previewUrl: "Libre+Caslon+Text",
    weights: ["400", "700"]
  },
  {
    importName: "LibreFranklin",
    fontFamily: "Libre Franklin",
    previewUrl: "Libre+Franklin",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "LilitaOne",
    fontFamily: "Lilita One",
    previewUrl: "Lilita+One",
    weights: ["400"]
  },
  {
    importName: "Lobster",
    fontFamily: "Lobster",
    previewUrl: "Lobster",
    weights: ["400"]
  },
  {
    importName: "LobsterTwo",
    fontFamily: "Lobster Two",
    previewUrl: "Lobster+Two",
    weights: ["400", "700"]
  },
  {
    importName: "Lora",
    fontFamily: "Lora",
    previewUrl: "Lora",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "LuckiestGuy",
    fontFamily: "Luckiest Guy",
    previewUrl: "Luckiest+Guy",
    weights: ["400"]
  },
  {
    importName: "MPLUS1p",
    fontFamily: "M PLUS Onep",
    previewUrl: "M+PLUS+1p",
    weights: ["100", "300", "400", "500", "700", "800", "900"]
  },
  {
    importName: "MPLUSRounded1c",
    fontFamily: "M PLUS Rounded Onec",
    previewUrl: "M+PLUS+Rounded+1c",
    weights: ["100", "300", "400", "500", "700", "800", "900"]
  },
  {
    importName: "Macondo",
    fontFamily: "Macondo",
    previewUrl: "Macondo",
    weights: ["400"]
  },
  {
    importName: "Manrope",
    fontFamily: "Manrope",
    previewUrl: "Manrope",
    weights: ["200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "Marcellus",
    fontFamily: "Marcellus",
    previewUrl: "Marcellus",
    weights: ["400"]
  },
  {
    importName: "Martel",
    fontFamily: "Martel",
    previewUrl: "Martel",
    weights: ["200", "300", "400", "600", "700", "800", "900"]
  },
  {
    importName: "Mate",
    fontFamily: "Mate",
    previewUrl: "Mate",
    weights: ["400"]
  },
  {
    importName: "MateSC",
    fontFamily: "Mate SC",
    previewUrl: "Mate+SC",
    weights: ["400"]
  },
  {
    importName: "MavenPro",
    fontFamily: "Maven Pro",
    previewUrl: "Maven+Pro",
    weights: ["400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Merienda",
    fontFamily: "Merienda",
    previewUrl: "Merienda",
    weights: ["300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Merriweather",
    fontFamily: "Merriweather",
    previewUrl: "Merriweather",
    weights: ["300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "MerriweatherSans",
    fontFamily: "Merriweather Sans",
    previewUrl: "Merriweather+Sans",
    weights: ["300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "Montserrat",
    fontFamily: "Montserrat",
    previewUrl: "Montserrat",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "MontserratAlternates",
    fontFamily: "Montserrat Alternates",
    previewUrl: "Montserrat+Alternates",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Mukta",
    fontFamily: "Mukta",
    previewUrl: "Mukta",
    weights: ["200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "Mulish",
    fontFamily: "Mulish",
    previewUrl: "Mulish",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NanumGothic",
    fontFamily: "Nanum Gothic",
    previewUrl: "Nanum+Gothic",
    weights: ["400", "700", "800"]
  },
  {
    importName: "NanumGothicCoding",
    fontFamily: "Nanum Gothic Coding",
    previewUrl: "Nanum+Gothic+Coding",
    weights: ["400", "700"]
  },
  {
    importName: "NanumMyeongjo",
    fontFamily: "Nanum Myeongjo",
    previewUrl: "Nanum+Myeongjo",
    weights: ["400", "700", "800"]
  },
  {
    importName: "Neuton",
    fontFamily: "Neuton",
    previewUrl: "Neuton",
    weights: ["200", "300", "400", "700", "800"]
  },
  {
    importName: "NoticiaText",
    fontFamily: "Noticia Text",
    previewUrl: "Noticia+Text",
    weights: ["400", "700"]
  },
  {
    importName: "NotoColorEmoji",
    fontFamily: "Noto Color Emoji",
    previewUrl: "Noto+Color+Emoji",
    weights: ["400"]
  },
  {
    importName: "NotoKufiArabic",
    fontFamily: "Noto Kufi Arabic",
    previewUrl: "Noto+Kufi+Arabic",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoNaskhArabic",
    fontFamily: "Noto Naskh Arabic",
    previewUrl: "Noto+Naskh+Arabic",
    weights: ["400", "500", "600", "700"]
  },
  {
    importName: "NotoSans",
    fontFamily: "Noto Sans",
    previewUrl: "Noto+Sans",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansArabic",
    fontFamily: "Noto Sans Arabic",
    previewUrl: "Noto+Sans+Arabic",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansBengali",
    fontFamily: "Noto Sans Bengali",
    previewUrl: "Noto+Sans+Bengali",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansDisplay",
    fontFamily: "Noto Sans Display",
    previewUrl: "Noto+Sans+Display",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansHK",
    fontFamily: "Noto Sans HK",
    previewUrl: "Noto+Sans+HK",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansJP",
    fontFamily: "Noto Sans JP",
    previewUrl: "Noto+Sans+JP",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansKR",
    fontFamily: "Noto Sans KR",
    previewUrl: "Noto+Sans+KR",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansMono",
    fontFamily: "Noto Sans Mono",
    previewUrl: "Noto+Sans+Mono",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansSC",
    fontFamily: "Noto Sans SC",
    previewUrl: "Noto+Sans+SC",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansTC",
    fontFamily: "Noto Sans TC",
    previewUrl: "Noto+Sans+TC",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSansThai",
    fontFamily: "Noto Sans Thai",
    previewUrl: "Noto+Sans+Thai",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSerif",
    fontFamily: "Noto Serif",
    previewUrl: "Noto+Serif",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSerifJP",
    fontFamily: "Noto Serif JP",
    previewUrl: "Noto+Serif+JP",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSerifKR",
    fontFamily: "Noto Serif KR",
    previewUrl: "Noto+Serif+KR",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NotoSerifTC",
    fontFamily: "Noto Serif TC",
    previewUrl: "Noto+Serif+TC",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Nunito",
    fontFamily: "Nunito",
    previewUrl: "Nunito",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "NunitoSans",
    fontFamily: "Nunito Sans",
    previewUrl: "Nunito+Sans",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "OldStandardTT",
    fontFamily: "Old Standard TT",
    previewUrl: "Old+Standard+TT",
    weights: ["400", "700"]
  },
  {
    importName: "OleoScript",
    fontFamily: "Oleo Script",
    previewUrl: "Oleo+Script",
    weights: ["400", "700"]
  },
  {
    importName: "OpenSans",
    fontFamily: "Open Sans",
    previewUrl: "Open+Sans",
    weights: ["300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "Orbitron",
    fontFamily: "Orbitron",
    previewUrl: "Orbitron",
    weights: ["400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Oswald",
    fontFamily: "Oswald",
    previewUrl: "Oswald",
    weights: ["200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "Outfit",
    fontFamily: "Outfit",
    previewUrl: "Outfit",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Overpass",
    fontFamily: "Overpass",
    previewUrl: "Overpass",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Oxygen",
    fontFamily: "Oxygen",
    previewUrl: "Oxygen",
    weights: ["300", "400", "700"]
  },
  {
    importName: "PTSans",
    fontFamily: "PT Sans",
    previewUrl: "PT+Sans",
    weights: ["400", "700"]
  },
  {
    importName: "PTSansCaption",
    fontFamily: "PT Sans Caption",
    previewUrl: "PT+Sans+Caption",
    weights: ["400", "700"]
  },
  {
    importName: "PTSansNarrow",
    fontFamily: "PT Sans Narrow",
    previewUrl: "PT+Sans+Narrow",
    weights: ["400", "700"]
  },
  {
    importName: "PTSerif",
    fontFamily: "PT Serif",
    previewUrl: "PT+Serif",
    weights: ["400", "700"]
  },
  {
    importName: "Pacifico",
    fontFamily: "Pacifico",
    previewUrl: "Pacifico",
    weights: ["400"]
  },
  {
    importName: "PassionOne",
    fontFamily: "Passion One",
    previewUrl: "Passion+One",
    weights: ["400", "700", "900"]
  },
  {
    importName: "PathwayGothicOne",
    fontFamily: "Pathway Gothic One",
    previewUrl: "Pathway+Gothic+One",
    weights: ["400"]
  },
  {
    importName: "PatuaOne",
    fontFamily: "Patua One",
    previewUrl: "Patua+One",
    weights: ["400"]
  },
  {
    importName: "PaytoneOne",
    fontFamily: "Paytone One",
    previewUrl: "Paytone+One",
    weights: ["400"]
  },
  {
    importName: "PermanentMarker",
    fontFamily: "Permanent Marker",
    previewUrl: "Permanent+Marker",
    weights: ["400"]
  },
  {
    importName: "Philosopher",
    fontFamily: "Philosopher",
    previewUrl: "Philosopher",
    weights: ["400", "700"]
  },
  {
    importName: "Play",
    fontFamily: "Play",
    previewUrl: "Play",
    weights: ["400", "700"]
  },
  {
    importName: "PlayfairDisplay",
    fontFamily: "Playfair Display",
    previewUrl: "Playfair+Display",
    weights: ["400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "PlusJakartaSans",
    fontFamily: "Plus Jakarta Sans",
    previewUrl: "Plus+Jakarta+Sans",
    weights: ["200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "Poppins",
    fontFamily: "Poppins",
    previewUrl: "Poppins",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Prata",
    fontFamily: "Prata",
    previewUrl: "Prata",
    weights: ["400"]
  },
  {
    importName: "Prompt",
    fontFamily: "Prompt",
    previewUrl: "Prompt",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "PublicSans",
    fontFamily: "Public Sans",
    previewUrl: "Public+Sans",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Quattrocento",
    fontFamily: "Quattrocento",
    previewUrl: "Quattrocento",
    weights: ["400", "700"]
  },
  {
    importName: "QuattrocentoSans",
    fontFamily: "Quattrocento Sans",
    previewUrl: "Quattrocento+Sans",
    weights: ["400", "700"]
  },
  {
    importName: "Questrial",
    fontFamily: "Questrial",
    previewUrl: "Questrial",
    weights: ["400"]
  },
  {
    importName: "Quicksand",
    fontFamily: "Quicksand",
    previewUrl: "Quicksand",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "Rajdhani",
    fontFamily: "Rajdhani",
    previewUrl: "Rajdhani",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "Raleway",
    fontFamily: "Raleway",
    previewUrl: "Raleway",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "ReadexPro",
    fontFamily: "Readex Pro",
    previewUrl: "Readex+Pro",
    weights: ["200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "RedHatDisplay",
    fontFamily: "Red Hat Display",
    previewUrl: "Red+Hat+Display",
    weights: ["300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Righteous",
    fontFamily: "Righteous",
    previewUrl: "Righteous",
    weights: ["400"]
  },
  {
    importName: "Roboto",
    fontFamily: "Roboto",
    previewUrl: "Roboto",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "RobotoCondensed",
    fontFamily: "Roboto Condensed",
    previewUrl: "Roboto+Condensed",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "RobotoFlex",
    fontFamily: "Roboto Flex",
    previewUrl: "Roboto+Flex",
    weights: ["400"]
  },
  {
    importName: "RobotoMono",
    fontFamily: "Roboto Mono",
    previewUrl: "Roboto+Mono",
    weights: ["100", "200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "RobotoSerif",
    fontFamily: "Roboto Serif",
    previewUrl: "Roboto+Serif",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "RobotoSlab",
    fontFamily: "Roboto Slab",
    previewUrl: "Roboto+Slab",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Rokkitt",
    fontFamily: "Rokkitt",
    previewUrl: "Rokkitt",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Rowdies",
    fontFamily: "Rowdies",
    previewUrl: "Rowdies",
    weights: ["300", "400", "700"]
  },
  {
    importName: "Rubik",
    fontFamily: "Rubik",
    previewUrl: "Rubik",
    weights: ["300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "RubikBubbles",
    fontFamily: "Rubik Bubbles",
    previewUrl: "Rubik+Bubbles",
    weights: ["400"]
  },
  {
    importName: "RubikMonoOne",
    fontFamily: "Rubik Mono One",
    previewUrl: "Rubik+Mono+One",
    weights: ["400"]
  },
  {
    importName: "RussoOne",
    fontFamily: "Russo One",
    previewUrl: "Russo+One",
    weights: ["400"]
  },
  {
    importName: "Sacramento",
    fontFamily: "Sacramento",
    previewUrl: "Sacramento",
    weights: ["400"]
  },
  {
    importName: "Saira",
    fontFamily: "Saira",
    previewUrl: "Saira",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "SairaCondensed",
    fontFamily: "Saira Condensed",
    previewUrl: "Saira+Condensed",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Sarabun",
    fontFamily: "Sarabun",
    previewUrl: "Sarabun",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "Satisfy",
    fontFamily: "Satisfy",
    previewUrl: "Satisfy",
    weights: ["400"]
  },
  {
    importName: "SawarabiGothic",
    fontFamily: "Sawarabi Gothic",
    previewUrl: "Sawarabi+Gothic",
    weights: ["400"]
  },
  {
    importName: "SawarabiMincho",
    fontFamily: "Sawarabi Mincho",
    previewUrl: "Sawarabi+Mincho",
    weights: ["400"]
  },
  {
    importName: "Sen",
    fontFamily: "Sen",
    previewUrl: "Sen",
    weights: ["400", "500", "600", "700", "800"]
  },
  {
    importName: "ShadowsIntoLight",
    fontFamily: "Shadows Into Light",
    previewUrl: "Shadows+Into+Light",
    weights: ["400"]
  },
  {
    importName: "Signika",
    fontFamily: "Signika",
    previewUrl: "Signika",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "SignikaNegative",
    fontFamily: "Signika Negative",
    previewUrl: "Signika+Negative",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "Silkscreen",
    fontFamily: "Silkscreen",
    previewUrl: "Silkscreen",
    weights: ["400", "700"]
  },
  {
    importName: "SixCaps",
    fontFamily: "Six Caps",
    previewUrl: "Six+Caps",
    weights: ["400"]
  },
  {
    importName: "Slabo27px",
    fontFamily: "Slabo TwoSevenpx",
    previewUrl: "Slabo+27px",
    weights: ["400"]
  },
  {
    importName: "Sora",
    fontFamily: "Sora",
    previewUrl: "Sora",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "SourceCodePro",
    fontFamily: "Source Code Pro",
    previewUrl: "Source+Code+Pro",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "SourceSans3",
    fontFamily: "Source Sans Three",
    previewUrl: "Source+Sans+3",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "SourceSerif4",
    fontFamily: "Source Serif Four",
    previewUrl: "Source+Serif+4",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "SpaceGrotesk",
    fontFamily: "Space Grotesk",
    previewUrl: "Space+Grotesk",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "SpaceMono",
    fontFamily: "Space Mono",
    previewUrl: "Space+Mono",
    weights: ["400", "700"]
  },
  {
    importName: "SpecialElite",
    fontFamily: "Special Elite",
    previewUrl: "Special+Elite",
    weights: ["400"]
  },
  {
    importName: "Spectral",
    fontFamily: "Spectral",
    previewUrl: "Spectral",
    weights: ["200", "300", "400", "500", "600", "700", "800"]
  },
  {
    importName: "Tajawal",
    fontFamily: "Tajawal",
    previewUrl: "Tajawal",
    weights: ["200", "300", "400", "500", "700", "800", "900"]
  },
  {
    importName: "Tangerine",
    fontFamily: "Tangerine",
    previewUrl: "Tangerine",
    weights: ["400", "700"]
  },
  {
    importName: "Teko",
    fontFamily: "Teko",
    previewUrl: "Teko",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "Tinos",
    fontFamily: "Tinos",
    previewUrl: "Tinos",
    weights: ["400", "700"]
  },
  {
    importName: "TitanOne",
    fontFamily: "Titan One",
    previewUrl: "Titan+One",
    weights: ["400"]
  },
  {
    importName: "TitilliumWeb",
    fontFamily: "Titillium Web",
    previewUrl: "Titillium+Web",
    weights: ["200", "300", "400", "600", "700", "900"]
  },
  {
    importName: "Ubuntu",
    fontFamily: "Ubuntu",
    previewUrl: "Ubuntu",
    weights: ["300", "400", "500", "700"]
  },
  {
    importName: "UbuntuCondensed",
    fontFamily: "Ubuntu Condensed",
    previewUrl: "Ubuntu+Condensed",
    weights: ["400"]
  },
  {
    importName: "UbuntuMono",
    fontFamily: "Ubuntu Mono",
    previewUrl: "Ubuntu+Mono",
    weights: ["400", "700"]
  },
  {
    importName: "Unbounded",
    fontFamily: "Unbounded",
    previewUrl: "Unbounded",
    weights: ["200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "Unna",
    fontFamily: "Unna",
    previewUrl: "Unna",
    weights: ["400", "700"]
  },
  {
    importName: "Urbanist",
    fontFamily: "Urbanist",
    previewUrl: "Urbanist",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "VarelaRound",
    fontFamily: "Varela Round",
    previewUrl: "Varela+Round",
    weights: ["400"]
  },
  {
    importName: "Vollkorn",
    fontFamily: "Vollkorn",
    previewUrl: "Vollkorn",
    weights: ["400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "WorkSans",
    fontFamily: "Work Sans",
    previewUrl: "Work+Sans",
    weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
  },
  {
    importName: "YanoneKaffeesatz",
    fontFamily: "Yanone Kaffeesatz",
    previewUrl: "Yanone+Kaffeesatz",
    weights: ["200", "300", "400", "500", "600", "700"]
  },
  {
    importName: "Yantramanav",
    fontFamily: "Yantramanav",
    previewUrl: "Yantramanav",
    weights: ["100", "300", "400", "500", "700", "900"]
  },
  {
    importName: "Yellowtail",
    fontFamily: "Yellowtail",
    previewUrl: "Yellowtail",
    weights: ["400"]
  },
  {
    importName: "YesevaOne",
    fontFamily: "Yeseva One",
    previewUrl: "Yeseva+One",
    weights: ["400"]
  },
  {
    importName: "ZenKakuGothicNew",
    fontFamily: "Zen Kaku Gothic New",
    previewUrl: "Zen+Kaku+Gothic+New",
    weights: ["300", "400", "500", "700", "900"]
  },
  {
    importName: "Zeyada",
    fontFamily: "Zeyada",
    previewUrl: "Zeyada",
    weights: ["400"]
  },
  {
    importName: "ZillaSlab",
    fontFamily: "Zilla Slab",
    previewUrl: "Zilla+Slab",
    weights: ["300", "400", "500", "600", "700"]
  },
  {
    importName: "TikTokSans",
    fontFamily: "TikTok Sans",
    previewUrl: "TikTok+Sans",
    weights: ["300", "400", "500", "600", "700", "800", "900"]
  }
];

// src/helpers/load-google-font-for-preview.ts
var fontLoads = new Map;
var loadGoogleFontForPreview = ({
  fontFamily,
  document: document2
}) => {
  const existing = fontLoads.get(fontFamily);
  if (existing) {
    return existing;
  }
  const font = GOOGLE_FONTS_LIST.find((entry) => entry.fontFamily === fontFamily);
  if (!font) {
    return Promise.resolve();
  }
  const commonWeights = font.weights.filter((weight) => ["400", "700", "800"].includes(weight));
  const weights = commonWeights.length ? commonWeights : font.weights.slice(0, 1);
  const promise = Promise.all(weights.map(async (weight) => {
    const response = await fetch(`https://fonts.googleapis.com/css?family=${font.previewUrl}:${weight}`);
    if (!response.ok) {
      throw new Error(`Could not load font "${fontFamily}" for Studio preview`);
    }
    const cssText = await response.text();
    const urls = [...cssText.matchAll(/url\(([^)]+)\)/g)].map((match) => match[1]);
    if (urls.length === 0) {
      throw new Error(`Could not load font "${fontFamily}" for Studio preview`);
    }
    await Promise.all(urls.map(async (url) => {
      const fontFace = new FontFace(fontFamily, `url(${url})`, { weight });
      await fontFace.load();
      document2.fonts.add(fontFace);
    }));
  })).then(() => {
    return;
  }).catch((error) => {
    fontLoads.delete(fontFamily);
    throw error;
  });
  fontLoads.set(fontFamily, promise);
  return promise;
};

// src/helpers/enqueue-studio-source-mutation.ts
var enqueueStudioSourceMutation = (endpoint, body, run) => {
  try {
    guardPendingEffectDeletion(endpoint, body);
  } catch (error) {
    return Promise.reject(error);
  }
  if (endpoint === "/api/undo" || endpoint === "/api/redo") {
    invalidateDuplicatedElementSelection();
    clearPendingSequenceSplits();
    Internals4.OptimisticEffectDeletion.clear();
  }
  const nodes = endpoint === "/api/delete-nodes" ? body.nodes.map((node) => ({
    absolutePath: node.fileName,
    nodePath: node.nodePath
  })) : [];
  const initialMutations = getPendingSequenceNodePathMutations();
  const mutations = [];
  const root = typeof window === "undefined" ? "" : window.remotion_cwd ?? "";
  let rebasedBody = body;
  let capturedBody = body;
  let rebaseError = null;
  let unsubscribeFromMutations = () => {};
  return enqueueSourceMutation(async (operation) => {
    try {
      if (rebaseError !== null) {
        throw rebaseError;
      }
      if (endpoint === "/api/save-sequence-props") {
        const fonts = body.edits.flatMap(({ sourceEdit }) => sourceEdit?.type === "google-font" ? [sourceEdit.font] : []);
        if (fonts.length > 0) {
          await Promise.all(fonts.map(({ fontFamily }) => loadGoogleFontForPreview({ fontFamily, document })));
          await installRequiredPackages([
            { name: "@remotion/google-fonts", version: null }
          ]);
        }
      }
      unsubscribeFromMutations();
      if (rebaseError !== null) {
        throw rebaseError;
      }
      const result = await run(rebasedBody);
      queueSequenceNodePathMutationFromApiResponse(result);
      const ownMutation = typeof result === "object" && result !== null && "nodePathMutation" in result && result.nodePathMutation ? result.nodePathMutation : null;
      markSourceRequestPaths(result, ownMutation ? [...mutations, ownMutation] : mutations, false);
      if (typeof result !== "object" || result === null) {
        return result;
      }
      if ("success" in result && result.success === false) {
        Internals4.OptimisticSequenceDeletion.rollbackRevision(operation.revision);
        return result;
      }
      if ((endpoint === "/api/undo" || endpoint === "/api/redo") && "nodePathMutation" in result && result.nodePathMutation) {
        const mutation = result.nodePathMutation;
        for (const file of mutation.files) {
          for (const remapping of file.remappings) {
            if (remapping.oldNodePath === null && remapping.newNodePath !== null) {
              Internals4.OptimisticSequenceDeletion.restore([
                {
                  absolutePath: file.absolutePath,
                  nodePath: remapping.newNodePath
                }
              ], operation.revision, false);
            } else if (remapping.newNodePath === null && remapping.oldNodePath !== null) {
              Internals4.OptimisticSequenceDeletion.restore([
                {
                  absolutePath: file.absolutePath,
                  nodePath: remapping.oldNodePath
                }
              ], operation.revision, true);
            }
          }
        }
      }
      return result;
    } catch (error) {
      Internals4.OptimisticSequenceDeletion.rollbackRevision(operation.revision);
      throw error;
    } finally {
      unsubscribeFromMutations();
    }
  }, (operation) => {
    try {
      capturedBody = captureSourceRequest(body, initialMutations);
      rebasedBody = capturedBody;
    } catch (error) {
      rebaseError = error;
      return;
    }
    if (endpoint === "/api/save-sequence-props") {
      supersedePendingSequenceSplits(body.edits.filter((edit) => [
        "from",
        "durationInFrames",
        "trimBefore",
        "playbackRate"
      ].includes(edit.key)).map((edit) => edit.nodePath));
    } else if (nodes.length > 0) {
      supersedePendingSequenceSplits(nodes);
    }
    if (nodes.length > 0) {
      Internals4.OptimisticSequenceDeletion.set(nodes, operation.revision, true);
    }
    const applyMutation = (mutation) => {
      mutations.push(mutation);
      if (rebaseError !== null) {
        return;
      }
      try {
        const nextBody = rebaseSourceRequest(capturedBody, mutations, false, root);
        if (nodes.length > 0) {
          const previousNodes = rebasedBody.nodes;
          const nextNodes = nextBody.nodes;
          queuePendingSequenceDeletionRemappings(mutation.mutationId, previousNodes.flatMap((previous, index) => {
            const next = nextNodes[index];
            if (JSON.stringify(previous.nodePath) === JSON.stringify(next.nodePath)) {
              return [];
            }
            return [
              {
                previousNodePath: {
                  absolutePath: previous.fileName,
                  nodePath: previous.nodePath
                },
                nodePath: {
                  absolutePath: next.fileName,
                  nodePath: next.nodePath
                },
                revision: operation.revision
              }
            ];
          }));
        }
        rebasedBody = nextBody;
      } catch (error) {
        rebaseError = error;
        if (nodes.length > 0) {
          queuePendingSequenceDeletionRemappings(mutation.mutationId, rebasedBody.nodes.map((node) => ({
            previousNodePath: {
              absolutePath: node.fileName,
              nodePath: node.nodePath
            },
            nodePath: null,
            revision: operation.revision
          })));
        }
      }
    };
    for (const mutation of initialMutations) {
      applyMutation(mutation);
    }
    unsubscribeFromMutations = subscribeToSequenceNodePathMutations(applyMutation);
  });
};

// src/components/call-api.ts
var callApiImmediately = (endpoint, body, signal) => {
  const run = () => new Promise((resolve, reject) => {
    fetch(endpoint, {
      method: "post",
      headers: {
        "content-type": "application/json"
      },
      signal,
      body: JSON.stringify(body)
    }).then((res) => res.json()).then((data) => {
      if (data.success) {
        queueSequenceNodePathMutationFromApiResponse(data.data);
        resolve(data.data);
      } else {
        reject(new Error(data.error));
      }
    }).catch((err) => {
      reject(err);
    });
  });
  return endpoint === "/api/subscribe-to-sequence-props" ? withSequenceSourceRead(body.requests.map((request) => request.fileName), run) : run();
};
var callApi = (endpoint, body, signal) => {
  if (!studioOperations2[endpoint].mutatesSource) {
    return callApiImmediately(endpoint, body, signal);
  }
  return enqueueStudioSourceMutation(endpoint, body, (rebasedBody) => callApiImmediately(endpoint, rebasedBody, signal));
};

// src/components/RenderModal/SchemaEditor/scroll-to-default-props-path.ts
import React6 from "react";
var DEFAULT_PROPS_PATH_CLASSNAME = "__remotion-default-props-editor-label";
var DEFAULT_PROPS_PATH_ACTIVE_CLASSNAME = "__remotion-default-props-editor-label-active";
var defaultPropsEditorScrollableAreaRef = React6.createRef();
var expandDefaultPropsEditorRef = React6.createRef();

// src/api/restart-studio.ts
import { getRemotionEnvironment as getRemotionEnvironment2 } from "remotion";
var restartStudio2 = () => {
  if (!getRemotionEnvironment2().isStudio) {
    throw new Error("restartStudio() is only available in the Studio");
  }
  if (getBrowserStudioOperations() !== null) {
    throw new Error("restartStudio() is not supported in Browser Studio");
  }
  if (window.remotion_isReadOnlyStudio) {
    throw new Error("restartStudio() is not available in read-only Studio");
  }
  return callApi("/api/restart-studio", {});
};

// src/components/RenderQueue/actions.ts
import { NoReactInternals as NoReactInternals2 } from "remotion/no-react";
var addStillRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  jpegQuality,
  frame,
  scale,
  logLevel,
  chromiumOptions,
  delayRenderTimeout,
  envVariables,
  inputProps,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  multiProcessOnLinux,
  beepOnFinish,
  metadata,
  chromeMode,
  mediaCacheSizeInBytes,
  preferredEffectBackend,
  licenseKey
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "still",
    outName,
    imageFormat,
    jpegQuality,
    frame,
    scale,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    multiProcessOnLinux,
    beepOnFinish,
    metadata,
    chromeMode,
    mediaCacheSizeInBytes,
    preferredEffectBackend,
    licenseKey
  });
};
var addSequenceRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  startFrame,
  endFrame,
  scale,
  logLevel,
  chromiumOptions,
  delayRenderTimeout,
  envVariables,
  inputProps,
  concurrency,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  jpegQuality,
  disallowParallelEncoding,
  multiProcessOnLinux,
  beepOnFinish,
  repro,
  metadata,
  chromeMode,
  mediaCacheSizeInBytes,
  preferredEffectBackend,
  licenseKey
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "sequence",
    outName,
    imageFormat,
    jpegQuality,
    scale,
    startFrame,
    endFrame,
    logLevel,
    chromiumOptions,
    delayRenderTimeout,
    envVariables,
    concurrency,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    disallowParallelEncoding,
    multiProcessOnLinux,
    beepOnFinish,
    repro,
    metadata,
    chromeMode,
    mediaCacheSizeInBytes,
    preferredEffectBackend,
    licenseKey
  });
};
var addVideoRenderJob = ({
  compositionId,
  outName,
  imageFormat,
  jpegQuality,
  scale,
  logLevel,
  codec,
  concurrency,
  crf,
  gopSize,
  startFrame,
  endFrame,
  muted,
  enforceAudioTrack,
  proResProfile,
  x264Preset,
  pixelFormat,
  audioBitrate,
  videoBitrate,
  everyNthFrame,
  numberOfGifLoops,
  delayRenderTimeout,
  audioCodec,
  disallowParallelEncoding,
  chromiumOptions,
  envVariables,
  inputProps,
  offthreadVideoCacheSizeInBytes,
  offthreadVideoThreads,
  colorSpace,
  multiProcessOnLinux,
  encodingMaxRate,
  encodingBufferSize,
  beepOnFinish,
  repro,
  forSeamlessAacConcatenation,
  separateAudioTo,
  metadata,
  hardwareAcceleration,
  chromeMode,
  mediaCacheSizeInBytes,
  preferredEffectBackend,
  sampleRate,
  licenseKey,
  prerenderTarget
}) => {
  return callApi("/api/render", {
    compositionId,
    type: "video",
    outName,
    imageFormat,
    jpegQuality,
    scale,
    logLevel,
    codec,
    concurrency,
    crf,
    gopSize,
    endFrame,
    startFrame,
    muted,
    enforceAudioTrack,
    proResProfile,
    x264Preset,
    pixelFormat,
    audioBitrate,
    videoBitrate,
    everyNthFrame,
    numberOfGifLoops,
    delayRenderTimeout,
    audioCodec,
    disallowParallelEncoding,
    chromiumOptions,
    envVariables,
    serializedInputPropsWithCustomSchema: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: inputProps,
      staticBase: window.remotion_staticBase,
      indent: undefined
    }).serializedString,
    offthreadVideoCacheSizeInBytes,
    offthreadVideoThreads,
    colorSpace,
    multiProcessOnLinux,
    encodingBufferSize,
    encodingMaxRate,
    beepOnFinish,
    repro,
    forSeamlessAacConcatenation,
    separateAudioTo,
    metadata,
    hardwareAcceleration,
    chromeMode,
    mediaCacheSizeInBytes,
    preferredEffectBackend,
    sampleRate,
    licenseKey,
    prerenderTarget
  });
};
var unsubscribeFromFileExistenceWatcher = ({
  file,
  clientId
}) => {
  return callApi("/api/unsubscribe-from-file-existence", { file, clientId });
};
var subscribeToFileExistenceWatcher = async ({
  file,
  clientId
}) => {
  const { exists } = await callApi("/api/subscribe-to-file-existence", {
    file,
    clientId
  });
  return exists;
};
var openInFileExplorer = ({ directory }) => {
  const body = {
    directory
  };
  return callApi("/api/open-in-file-explorer", body);
};
var addComposition2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/add-composition", request, signal) : operations.addComposition(request);
};
var duplicateComposition2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/duplicate-composition", request, signal) : operations.duplicateComposition(request);
};
var renameComposition2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/rename-composition", request, signal) : operations.renameComposition(request);
};
var updateCompositionMetadata2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/update-composition-metadata", request, signal) : operations.updateCompositionMetadata(request);
};
var deleteComposition2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/delete-composition", request, signal) : operations.deleteComposition(request);
};
var moveComposition2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/move-composition", request, signal) : operations.moveComposition(request);
};
var addFolder2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/add-folder", request, signal) : operations.addFolder(request);
};
var renameFolder2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/rename-folder", request, signal) : operations.renameFolder(request);
};
var unwrapFolder2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/unwrap-folder", request, signal) : operations.unwrapFolder(request);
};
var moveFolder2 = (request, signal) => {
  const operations = getBrowserStudioOperations();
  return operations === null ? callApi("/api/move-folder", request, signal) : operations.moveFolder(request);
};
var removeRenderJob = (job) => {
  return callApi("/api/remove-render", {
    jobId: job.id
  });
};
var cancelRenderJob = (job) => {
  return callApi("/api/cancel", {
    jobId: job.id
  });
};
var updateAvailable = (signal) => {
  return callApi("/api/update-available", {}, signal);
};
var getReleaseNotes = (currentVersion, latestVersion, signal) => {
  return callApi("/api/release-notes", { currentVersion, latestVersion }, signal);
};
var callUpdateDefaultPropsApi = (compositionId, defaultProps, enumPaths, symbolicatedStack) => {
  const body = {
    compositionId,
    defaultProps: NoReactInternals2.serializeJSONWithSpecialTypes({
      data: defaultProps,
      indent: undefined,
      staticBase: window.remotion_staticBase
    }).serializedString,
    enumPaths,
    symbolicatedStack
  };
  const browserStudioOperations = getBrowserStudioOperations();
  if (browserStudioOperations !== null) {
    return browserStudioOperations.updateDefaultProps(body);
  }
  return callApi("/api/update-default-props", body);
};
var applyVisualControlChange = ({
  fileName,
  changes
}) => {
  return callApi("/api/apply-visual-control-change", {
    fileName,
    changes
  });
};

// src/components/Timeline/TimelineStack/get-stack.ts
import {
  sourceContentFor,
  TraceMap as TraceMap2
} from "@jridgewell/trace-mapping";
import { Internals as Internals5 } from "remotion";

// src/error-overlay/react-overlay/utils/get-source-map.ts
import { TraceMap, originalPositionFor } from "@jridgewell/trace-mapping";
var getOriginalPosition = (sourceMap, line, column) => {
  const result = originalPositionFor(sourceMap, {
    line,
    column
  });
  return { line: result.line, column: result.column, source: result.source };
};
function extractSourceMapUrl(fileContents) {
  const regex = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/gm;
  let match = null;
  for (;; ) {
    const next = regex.exec(fileContents);
    if (next == null) {
      break;
    }
    match = next;
  }
  if (!match?.[1]) {
    return null;
  }
  return match[1].toString();
}
async function getSourceMap(fileUri, fileContents) {
  const sm = extractSourceMapUrl(fileContents);
  if (sm === null) {
    return null;
  }
  if (sm.indexOf("data:") === 0) {
    const base64 = /^data:application\/json;([\w=:"-]+;)*base64,/;
    const match2 = sm.match(base64);
    if (!match2) {
      throw new Error("Sorry, non-base64 inline source-map encoding is not supported.");
    }
    const converted = window.atob(sm.substring(match2[0].length));
    return new TraceMap(JSON.parse(converted));
  }
  const index = fileUri.lastIndexOf("/");
  const url = fileUri.substring(0, index + 1) + sm;
  const obj = await fetch(url).then((res) => res.json());
  return new TraceMap(obj);
}

// src/error-overlay/react-overlay/utils/parser.ts
import { getLocationFromBuildError } from "@remotion/studio-shared";

// src/error-overlay/react-overlay/effects/resolve-file-source.ts
var resolveFileSource = async (location, contextLines) => {
  const browserStudioOperations = getBrowserStudioOperations();
  let text;
  if (browserStudioOperations) {
    const browserSource = await browserStudioOperations.getFileSource(location.fileName);
    if (browserSource === null) {
      throw new Error(`Could not find ${location.fileName}`);
    }
    text = browserSource;
  } else {
    const response = await fetch(`/api/file-source?f=${encodeURIComponent(location.fileName)}`);
    if (!response.ok) {
      throw new Error(`Could not load source for ${location.fileName}`);
    }
    text = await response.text();
  }
  const lines = text.split(`
`).map((l, i) => {
    const oneIndexedLineNumber = i + 1;
    return [oneIndexedLineNumber, l];
  }).filter(([oneIndexedLineNumber]) => {
    return Math.abs(oneIndexedLineNumber - location.lineNumber) <= contextLines;
  });
  const scriptCode = lines.map(([num, line]) => {
    return {
      content: line,
      highlight: location.lineNumber === num,
      lineNumber: num
    };
  });
  return {
    originalColumnNumber: location.columnNumber,
    originalFunctionName: null,
    originalFileName: location.fileName,
    originalLineNumber: location.lineNumber,
    originalScriptCode: scriptCode
  };
};

// src/error-overlay/react-overlay/utils/make-stack-frame.ts
var makeStackFrame = ({
  functionName,
  fileName,
  lineNumber,
  columnNumber
}) => {
  if (functionName && functionName.indexOf("Object.") === 0) {
    functionName = functionName.slice("Object.".length);
  }
  if (functionName === "friendlySyntaxErrorLabel" || functionName === "exports.__esModule" || functionName === "<anonymous>" || !functionName) {
    functionName = null;
  }
  return {
    columnNumber,
    fileName,
    functionName,
    lineNumber
  };
};

// src/error-overlay/react-overlay/utils/parser.ts
var regexExtractLocation = /\(?(.+?)(?::(\d+))?(?::(\d+))?\)?$/;
function extractLocation(token) {
  const execed = regexExtractLocation.exec(token);
  if (!execed) {
    throw new Error("Could not match in extractLocation");
  }
  return execed.slice(1).map((v) => {
    const p = Number(v);
    if (!isNaN(p)) {
      return p;
    }
    return v;
  });
}
var regexValidFrame_Chrome = /^\s*(at|in)\s.+(:\d+)/;
var regexValidFrame_FireFox = /(^|@)\S+:\d+|.+line\s+\d+\s+>\s+(eval|Function).+/;
function parseStack(stack) {
  const frames = stack.filter((e) => regexValidFrame_Chrome.test(e) || regexValidFrame_FireFox.test(e)).map((e) => {
    if (regexValidFrame_FireFox.test(e)) {
      let isEval = false;
      if (/ > (eval|Function)/.test(e)) {
        e = e.replace(/ line (\d+)(?: > eval line \d+)* > (eval|Function):\d+:\d+/g, ":$1");
        isEval = true;
      }
      const _data = e.split(/[@]/g);
      const _last = _data.pop();
      if (!_last) {
        throw new Error("could not get last");
      }
      const [_fileName, _lineNumber, _columnNumber] = extractLocation(_last);
      return makeStackFrame({
        functionName: _data.join("@") || (isEval ? "eval" : null),
        fileName: _fileName,
        lineNumber: _lineNumber,
        columnNumber: _columnNumber
      });
    }
    if (e.indexOf("(eval ") !== -1) {
      e = e.replace(/(\(eval at [^()]*)|(\),.*$)/g, "");
    }
    if (e.indexOf("(at ") !== -1) {
      e = e.replace(/\(at /, "(");
    }
    const data = e.trim().split(/\s+/g).slice(1);
    const last = data.pop();
    if (!last) {
      throw new Error("could not get last");
    }
    const [fileName, lineNumber, columnNumber] = extractLocation(last);
    return makeStackFrame({
      functionName: data.join(" ") || null,
      fileName,
      lineNumber,
      columnNumber
    });
  });
  return frames;
}
var parseError = async (error, contextLines) => {
  if (error === null) {
    throw new Error("You cannot pass a null object.");
  }
  if (typeof error === "string") {
    return parseStack(error.split(`
`)).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  if (Array.isArray(error)) {
    return parseStack(error).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  const errorLocation = getLocationFromBuildError(error);
  if (errorLocation) {
    return [
      {
        type: "symbolicated",
        frame: await resolveFileSource(errorLocation, contextLines)
      }
    ];
  }
  if (typeof error.stack === "string") {
    return parseStack(error.stack.split(`
`)).map((frame) => {
      return {
        type: "transpiled",
        frame
      };
    });
  }
  return [];
};

// src/helpers/get-location-of-sequence.ts
var getLocationOfSequence = (stack) => {
  if (!stack) {
    return null;
  }
  const parsed = parseStack(stack.split(`
`));
  let i = 0;
  while (i < parsed.length) {
    const frame = parsed[i];
    if (frame.functionName === "apply") {
      i++;
      continue;
    }
    return frame;
  }
  return null;
};
var getLocationOfFunctionCall = (stack, functionName) => {
  if (!stack) {
    return null;
  }
  const parsed = parseStack(stack.split(`
`));
  let i = 0;
  while (i < parsed.length) {
    const frame = parsed[i];
    if (frame.functionName !== functionName) {
      i++;
      continue;
    }
    return parsed[i + 1];
  }
  return null;
};

// src/components/Timeline/TimelineStack/get-stack.ts
var traceMapCache = {};
var traceMapPromises = {};
var traceMapsByOriginalSource = new Map;
var sourceMapFilesCache = new WeakMap;
var compiledSourceFrame = `
    at remotionCompiledSource (remotion-source-sha256:`;
var getSequenceLocationStack = (stack) => {
  const index = stack?.lastIndexOf(compiledSourceFrame) ?? -1;
  if (!stack || index === -1) {
    return stack;
  }
  const source = Internals5.parseOriginalSourceStack(stack);
  return source && !hasSourceOnlyRemappings(source.fileName) ? stack.slice(0, index) : stack;
};
var getCompiledSourceHash = (stack, fileName) => {
  const originalSource = Internals5.parseOriginalSourceStack(stack);
  if (originalSource) {
    return originalSource.fileName === fileName ? stack?.match(/\n {4}at remotionCompiledSource \(remotion-source-sha256:([a-f0-9]{64})\)$/)?.[1] ?? null : null;
  }
  const location = getLocationOfSequence(stack);
  const map = location ? traceMapCache[location.fileName] : null;
  if (!map) {
    return null;
  }
  return sourceContentFor(map, fileName)?.slice(-96).match(/\/\* remotion-source-sha256:([a-f0-9]{64}) \*\/\s*$/)?.[1] ?? null;
};
var isInternalSource = (source) => {
  if (source === null) {
    return false;
  }
  const normalizedSource = source.replaceAll("\\", "/");
  return /(?:^|\/)node_modules\//.test(normalizedSource) || /(?:^|\/)dist\/(?:[^/]+\/)*[^/]+\.(?:cjs|mjs|js)$/.test(normalizedSource) || /(?:^|\/)(?:packages\/)?core\/src\//.test(normalizedSource);
};
var getSourceMapCache = (fileName) => {
  if (traceMapCache[fileName]) {
    return Promise.resolve(traceMapCache[fileName]);
  }
  if (traceMapPromises[fileName]) {
    return traceMapPromises[fileName];
  }
  traceMapPromises[fileName] = fetch(`${fileName}.map`).then((res) => res.json()).then((json) => {
    const map = new TraceMap2(json);
    traceMapCache[fileName] = map;
    for (let index = 0;index < map.sources.length; index++) {
      const source = map.sources[index];
      const content = map.sourcesContent?.[index];
      if (source !== null && typeof content === "string") {
        traceMapsByOriginalSource.set(source, map);
      }
    }
    return map;
  }).finally(() => {
    delete traceMapPromises[fileName];
  });
  return traceMapPromises[fileName];
};
var getSourceMapFilesForSource = (source) => {
  const map = traceMapsByOriginalSource.get(source);
  if (!map) {
    return null;
  }
  const cached = sourceMapFilesCache.get(map);
  if (cached) {
    return cached;
  }
  const files = {};
  for (let index = 0;index < map.sources.length; index++) {
    const fileName = map.sources[index];
    const content = map.sourcesContent?.[index];
    if (fileName !== null && typeof content === "string") {
      files[fileName] = content;
    }
  }
  sourceMapFilesCache.set(map, files);
  return files;
};
var getOriginalLocationFromStack = async (stack, type) => {
  const location = type === "sequence" ? getLocationOfSequence(stack) : getLocationOfFunctionCall(stack, "visualControl");
  if (!location) {
    return null;
  }
  const originalSource = Internals5.parseOriginalSourceStack(stack);
  if (originalSource) {
    if (isInternalSource(originalSource.fileName)) {
      return null;
    }
    return {
      column: originalSource.column,
      line: originalSource.line,
      source: originalSource.fileName
    };
  }
  const map = await getSourceMapCache(location.fileName);
  const originalPosition = getOriginalPosition(map, location.lineNumber, Math.max(0, location.columnNumber - 1));
  return isInternalSource(originalPosition.source) ? null : originalPosition;
};

export { AppsIcon, CodingAgentIcon, EditorIcon, FinderIcon, TerminalIcon, copySourcePathProvenance, normalizeSourceFileName, cancelDuplicatedElementSelection, invalidateDuplicatedElementSelection, setDuplicationSelectionComposition, beginDuplicatedElementSelection, resolveDuplicatedElementSelection, markDuplicationSelectionMutationsApplied, getDuplicatedElementSelection, subscribeToDuplicatedElementSelection, requestInsertedElementSelection, clearInsertedElementSelection, subscribeToInsertedElementSelection, getInsertedElementSelection, getSourceMutationRevision, subscribeToInstalledMutationBuild, recordSequenceNodePathMutationBuild, recordUnchangedSequenceNodePathMutationBuild, hasSourceOnlyRemappings, subscribeToSequenceNodePathMutations, queueSequenceNodePathMutation, takePendingSequenceNodePathMutations, useSyncExternalStore, clearPendingSequenceSplits, getPendingSequenceSplits, isSequenceSplitPending, useAreSequencesSplitting, useIsSplittingSequence, beginPendingSequenceSplit, finishPendingSequenceSplit, acknowledgePendingSequenceSplit, reconcilePendingSequenceSplits, observePendingSequenceSplitSourceVersion, getPendingEffectDeletions, isEffectDeletionPending, usePendingEffectDeletions, useIsEffectDeletionPending, assertEffectChainEditable, remapOptimisticEffectDeletions, getEffectDeletionSelectionRevision, invalidateEffectDeletionSelection, authorizeEffectDeletionRequest, BROWSER_STUDIO_OPERATIONS_READY_EVENT, getBrowserStudioOperations, getBrowserStudioEffectOperations, canUseKeyframeOperations, canUseEffectOperations, canInstallPackages, TRANSFORMERS_PACKAGE, withRequiredAuxiliaryPackages, installPackages, isPointerSessionRelease, observePointerRelease, startCapturedPointerSession, startDeferredCapturedPointerSession, isMac, getStudioAskAIEnabled, getStudioInteractivityEnabled, getStudioKeyboardShortcutsEnabled, getStudioMaxTimelineTracks, getStudioBufferStateDelayInMilliseconds, getStudioDefaultPremountInSeconds, getStudioShowPremounting, getStudioShowLayerFrameNumbers, getStudioSequenceActivitySettings, defaultKeyboardShortcuts, keyboardShortcutGroups, askAIKeyboardShortcutGroup, getKeyboardShortcutsForAction, keyboardShortcutsOverlap, formatKeyboardShortcut, getKeyboardShortcutLabel, getKeyboardShortcutAriaKeyShortcuts, shortcutFromKeyboardEvent, KeybindingContextProvider, areKeyboardShortcutsDisabled, useKeybinding, HighestZIndexProvider, getClickLock, setClickLock, HigherZIndex, useZIndex, portals, getPortal, showNotification, NotificationCenter, getMissingPackages, installRequiredPackages, GOOGLE_FONTS_LIST, loadGoogleFontForPreview, callApi, DEFAULT_PROPS_PATH_CLASSNAME, DEFAULT_PROPS_PATH_ACTIVE_CLASSNAME, defaultPropsEditorScrollableAreaRef, expandDefaultPropsEditorRef, restartStudio2, addStillRenderJob, addSequenceRenderJob, addVideoRenderJob, unsubscribeFromFileExistenceWatcher, subscribeToFileExistenceWatcher, openInFileExplorer, addComposition2, duplicateComposition2, renameComposition2, updateCompositionMetadata2, deleteComposition2, moveComposition2, addFolder2, renameFolder2, unwrapFolder2, moveFolder2, removeRenderJob, cancelRenderJob, updateAvailable, getReleaseNotes, callUpdateDefaultPropsApi, applyVisualControlChange, getOriginalPosition, getSourceMap, resolveFileSource, parseError, compiledSourceFrame, getSequenceLocationStack, getCompiledSourceHash, getSourceMapFilesForSource, getOriginalLocationFromStack };
